import React, { Component } from "react";
import { branch } from "baobab-react/higher-order";
import autoBind from "react-autobind";
import { saveAs } from "file-saver";
import _ from "lodash";
import {
	Button,
	FormControl,
	FormGroup,
	Col,
	ControlLabel,
	Panel,
	ButtonGroup,
	MenuItem,
	DropdownButton,
	HelpBlock,
	InputGroup,
	Breadcrumb,
	Checkbox
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Modal from "react-responsive-modal";
import ReactPlayer from "react-player";
import ReactAudioPlayer from "react-audio-player";
import { copyToClipboard, readClipboardContents, readPasteEventContents } from "../../utils/clipboard";
import request from "superagent";

import {
	listDrive,
	listDriveMap,
	listDriveForSelectedFolderSilently,
	refreshSelectedDriveFolder,
	moveFile,
	getResourceReference,
	createFolder,
	uploadFile,
	uploadAndOptimizeMediaFile,
	deleteFile,
	deleteDriveObjectsBulk,
	deleteFolder,
	moveFolder,
	copyFile,
	copyFolder,
	filterHierarchy,
	setNodeActive,
	setNodeToggle,
	handleSwitchHierarchyMode,
	getUrlForResource,
	getContent,
	getContentRaw,
	getDriveObjectsAsMap,
	uploadContent,
	processExistingDriveVideoFile,
	showSpinner,
	hideSpinner,
	selectFolderAndListDrive,
	clearSelectionAndActiveTreeCursor,
	listDriveForSelectedFolder,
	setActiveTreeCursorForDriveGuid,
	getFullObjectPath,
	getUrlForExternalResource
} from "../../actions/drive";
import { showError, showConfirm, showInfoToast, showSuccessToast } from "../../actions/alertActions";
import { getDriveRootPath } from "../../actions/activityActions";
import { AmbifiLoader } from "../shared/";
import ListView from "./views/listView";
import { getMediaType } from "../..//utils/mediaUtils";
import {
	getAudioTranscriptionsLambda,
	getAwsTranscribeLambda,
	getImageDescriptionsLambda,
	getPdfResponsesLambda,
	getRekognitionTagsLambda,
	getResponsesCreateLambda
} from "../../ai/aiAssistant";
import {
	getFileTypeIcon,
	validateUrl,
	generateUUID,
	generatePastedImageFileName
} from "../../utils/utils";
import DriveContext from "./driveContext";
import styles from "./drive.module.css";
import { showMediaPreviewModal } from "../../actions/actions";
import env from "../../constants/env";
import { getClient2 } from "../../search/algolia";

import { getOrgId } from "../../actions/orgsActions";
import { getJwtToken } from "../../actions/user";
import SearchInput from "./searchInput";
import SearchResultsView from "./searchResults";
import { refreshCredentials } from "../../utils/securityUtil";
import ImageEditorModal from "../shared/imageEditorModal";
import VideoProcessingAdvancedToggle from "../shared/videoProcessingAdvancedToggle";
import VideoProcessingOptionsModal from "../shared/videoProcessingOptionsModal";
import { isImageToolsEnabledForUrlParams, isMediaToolsEnabledForUrlParams } from "../../utils/mediaTools";
import { isTopLevelFolderFile } from "../../utils/assetFolderImportUtils";
import {
	getDefaultVideoOrientationSummary,
	buildEditedVideoOutputFileName,
	getStoredVideoProcessingOptions,
	isVideoAdvancedOptionsEnabled,
	VIDEO_AUDIO_PRESET_OPTIONS,
	VIDEO_FRAMING_PRESET_OPTIONS,
	VIDEO_ROTATION_PRESET_OPTIONS,
	VIDEO_RESIZE_PRESET_OPTIONS,
	VIDEO_STYLE_FILTER_PRESET_OPTIONS,
	VIDEO_TONE_MAP_PRESET_OPTIONS,
	setStoredVideoProcessingOptions,
	setVideoAdvancedOptionsEnabled,
	summarizeVideoFileOrientations,
	shouldPromptForVideoProcessing,
	isVideoFileCandidate
} from "../../utils/videoProcessingOptions";

const RESERVED_FOLDER_NAMES = ["children", "parent", "path", "this"];
const MAX_METADATA_TITLE_CHARS = 120;
const MAX_METADATA_DESCRIPTION_CHARS = 600;
const MAX_METADATA_TRANSCRIPT_CHARS = 20000;
const MAX_METADATA_TRANSCRIPT_VTT_CHARS = 250000;
const TRANSCRIPT_PROVIDER_OPENAI = "openai";
const TRANSCRIPT_PROVIDER_AWS_TRANSCRIBE = "aws-transcribe";
const TAGS_PROVIDER_OPENAI = "openai";
const TAGS_PROVIDER_REKOGNITION = "rekognition";

function FieldGroup({ id, label, help, ...props }) {
	return (
		<FormGroup controlId={id}>
			<ControlLabel>{label}</ControlLabel>
			<FormControl {...props} />
			{help && <HelpBlock>{help}</HelpBlock>}
		</FormGroup>
	);
}

function normalizeEditorContentForSave(content) {
	if (_.isNil(content)) {
		return "";
	}

	if (_.isString(content)) {
		return content;
	}

	return JSON.stringify(content, null, 4);
}

function getDriveImageEditorSource(resource = null) {
	if (!resource || resource.type !== "file" || getDriveResourceMediaType(resource) !== "image") {
		return null;
	}

	const resourceName = resource.name || "image";
	const resourceStem = `${resourceName}`.replace(/\.[^/.]+$/, "") || "image";

	return {
		url: getUrlForExternalResource(resource),
		label: resourceName,
		defaultBaseName: `${resourceStem}-edited`,
		driveObjectGuid: resource.guid || null,
		originalImageName: resource.name || `${resourceStem}.png`,
		overwriteTargetPath: resource.path || ""
	};
}

function getDriveResourceMediaType(resource = null) {
	if (!resource || resource.type !== "file") {
		return null;
	}

	const metaType = `${_.get(resource, "metaData.type", "")}`.trim().toLowerCase();
	if (["image", "video", "audio", "pdf"].includes(metaType)) {
		return metaType;
	}

	const contentType = `${resource.contentType || resource.mimeType || _.get(resource, "metaData.contentType", "") || _.get(resource, "metaData.mimeType", "")}`.trim().toLowerCase();
	if (contentType.startsWith("image/")) {
		return "image";
	}
	if (contentType.startsWith("video/")) {
		return "video";
	}
	if (contentType.startsWith("audio/")) {
		return "audio";
	}
	if (contentType === "application/pdf") {
		return "pdf";
	}

	const candidates = [
		resource.ext,
		resource.name,
		resource.fileName,
		Array.isArray(resource.path) ? resource.path.join("/") : resource.path
	];
	for (const candidate of candidates) {
		const value = `${candidate || ""}`.trim();
		if (!value) {
			continue;
		}
		const ext = value.includes(".") ? value.split(".").pop() : value;
		const mediaType = getMediaType(ext);
		if (mediaType) {
			return mediaType;
		}
	}

	return null;
}

function getDriveVideoEditorSource(resource = null) {
	if (!resource || resource.type !== "file" || getDriveResourceMediaType(resource) !== "video") {
		return null;
	}

	const resourceName = resource.name || "video.mp4";
	const resourceStem = `${resourceName}`.replace(/\.[^/.]+$/, "") || "video";
	const resourcePath = Array.isArray(resource.path) ? resource.path.join("/") : (resource.path || "");

	return {
		url: getUrlForExternalResource(resource),
		label: resourceName,
		defaultOutputFileName: buildEditedVideoOutputFileName(resourceName),
		driveObjectGuid: resource.guid || null,
		videoFileName: resource.name || `${resourceStem}.mp4`,
		overwriteTargetPath: resourcePath,
		resource
	};
}

class Drive extends Component {
	constructor(props) {
		super(props);
		this.currentEditor = React.createRef();
		this.pasteClipboardTarget = React.createRef();
		this.driveComponentId = generateUUID();
		this.videoProcessingPollTimeout = null;
		this.videoProcessingPollInFlight = false;
		this.pasteClipboardDocumentListening = false;
		this.state = {
			cursor: null,
			data: null,
			showCreateFolderModal: false,
			showPasteClipboardModal: false,
			pasteClipboardFileName: "",
			pasteClipboardText: "",
			pasteClipboardContentType: "text/plain",
			pasteClipboardFile: null,
			pasteClipboardPreviewUrl: "",
			pasteClipboardWaitingForPaste: false,
			pasteClipboardPasteError: "",
			pasteClipboardSaving: false,
			showUploadFileModal: false,
			rename: {},
			editorState: {
				content: "",
				validity: { valid: true, error: null }
			},
			filter: props.filter ? props.filter : "",
			driveInitialized: false,

				// new features
				showAllLabels: false,
				isSearchMode: false,
				searchImageFiles: [],
				showGallery: false,
				galleryIndex: 0,
				galleryImages: [],
				selectedNode: null,
				showTagsModal: false,
				tagsEditorInput: "",
				tagsEditorPrimary: [],
				tagsEditorSecondary: [],
				tagsEditorSaving: false,
				tagsEditorLoadingSuggestions: false,
				metadataEditorTitle: "",
				metadataEditorDescription: "",
				metadataEditorTranscript: "",
				metadataEditorTranscriptVtt: "",
				showImageEditorModal: false,
				imageEditorTarget: null,
				showVideoEditorModal: false,
				videoEditorTarget: null,
				metadataGeneratingField: "",
				metadataTranscriptProvider: TRANSCRIPT_PROVIDER_AWS_TRANSCRIBE,
				metadataTagsProvider: TAGS_PROVIDER_OPENAI,
				showAdvancedVideoOptions: isVideoAdvancedOptionsEnabled(),
				showVideoProcessingOptionsModal: false,
				pendingUploadFiles: [],
				pendingUploadOrientationSummary: getDefaultVideoOrientationSummary(),
				showUploadFolderOptionsModal: false,
				uploadFolderRecursive: true,
				processingUploads: {},
				showDeleteOptionsModal: false,
				deleteDialogTarget: null,
				deleteDialogRelatedItems: [],
				deleteDialogDeleteRelated: true
			};
		autoBind(this);
	}

	toggleShowAllLabels() {
		this.setState((prev) => ({ showAllLabels: !prev.showAllLabels }));
	}

	openGallery(startIndex = 0) {
		const allImages = this.getVisibleMediaFiles();
		this.setState({
			showGallery: true,
			galleryIndex: Math.max(0, Math.min(startIndex, Math.max(0, allImages.length - 1))),
			galleryImages: allImages
		});
	}

	getVisibleMediaFiles() {
		const { hierarchy } = this.props;
		const { isSearchMode, searchImageFiles } = this.state;

		const allowed = new Set(["image", "video", "audio", "pdf"]);
		const source = isSearchMode ? (searchImageFiles ?? []) : ((hierarchy && hierarchy.children) || []);

		return source.filter((node) => {
			if (!node || node.type !== "file") { return false; }
			try {
				const t = node?.ext ? getMediaType(node.ext) : null;
				return allowed.has(t);
			} catch {
				return false;
			}
		});
	}

	handleNextImage = () => {
		this.setState((prev) => {
			const len = prev.galleryImages.length || 0;
			if (!len) { return null; }
			return { galleryIndex: (prev.galleryIndex + 1) % len };
		});
	};

	handlePrevImage = () => {
		this.setState((prev) => {
			const len = prev.galleryImages.length || 0;
			if (!len) { return null; }
			return { galleryIndex: (prev.galleryIndex - 1 + len) % len };
		});
	};

	onToggle(node, toggled) {
		const { cursor } = this.state;
		const { okCancel } = this.props;

		if (node.children) {
			const _toggled = (!node.hasOwnProperty("allowCollapse") || node.allowCollapse) ? toggled : true;
			setNodeToggle(node.guid, _toggled);
		}
		if (cursor && cursor !== node) {
			setNodeActive(cursor.guid, false);
		}
		setNodeActive(node.guid, true);

		if (!okCancel) {
			if (node.type === "file" && this.props.onFileSelected) {
				this.props.onFileSelected(node);
			} else if (node.type === "folder" && this.props.onFolderSelected) {
				this.props.onFolderSelected(node);
			} else if (this.props.onItemSelected) {
				this.props.onItemSelected(getResourceReference(node));
			}
		}
		this.setState({ cursor: node });
	}

	onSelect(node) {
		const { cursor } = this.state;
		const { okCancel } = this.props;

		clearSelectionAndActiveTreeCursor();

		if (cursor && cursor !== node) {
			setNodeActive(cursor.guid, false, null);
		}
		setNodeActive(node.guid, true, node);

		if (!okCancel) {
			if (node.type === "file" && this.props.onFileSelected) {
				this.props.onFileSelected(node);
			} else if (node.type === "folder" && this.props.onFolderSelected) {
				this.props.onFolderSelected(node);
			} else if (this.props.onItemSelected) {
				this.props.onItemSelected(getResourceReference(node));
			}
		}

		this.setState({ cursor: node, selectedNode: node });
	}

	async onDblClick(node) {
		if (node.type === "folder") {
			this.handleSelectFolderAndListDrive(node.fullPath);
		}
	}

	onFilterChange(e) {
		const filter = e.target.value.trim();
		this.setState({ filter });
		filterHierarchy(filter);
	}

	handleStartMove() {
		const { cursor } = this.state;
		const { hierarchy } = this.props;
		this.setState({
			moving: true,
			moveInfo: {
				origin: _.cloneDeep(cursor),
				originParentFolderPath: hierarchy.fullPath
			}
		});
	}

	handleStartCopy() {
		const { cursor } = this.state;
		const { hierarchy } = this.props;
		this.setState({
			copying: true,
			copyInfo: {
				origin: _.cloneDeep(cursor),
				originParentFolderPath: hierarchy.fullPath
			}
		});
	}

	handleCancelMove() {
		this.setState({ moving: false, moveInfo: null });
	}

	handleCancelCopy() {
		this.setState({ copying: false, copyInfo: null });
	}

	handleMove() {
		const { moveInfo } = this.state;
		const { hierarchy } = this.props;
		if (hierarchy.type === "folder") {
			if (moveInfo.origin.type === "file") {
				const destinationPath = _.concat(hierarchy.path, moveInfo.origin.fileName).join("/");
				moveFile(moveInfo.origin.guid, destinationPath)
					.then(this.handleCancelMove)
					.catch((err) => showError("Move File", `Failed to move file ${moveInfo.origin.guid} to ${destinationPath}, reason: ${err}`));
			} else {
				const destinationPath = _.concat(hierarchy.path, moveInfo.origin.name).join("/");
				moveFolder(moveInfo.origin, destinationPath)
					.then(this.handleCancelMove)
					.catch((err) => showError("Move Folder", `Failed to move folder ${moveInfo.origin.guid} to ${destinationPath}, reason: ${err}`));
			}
		} else {
			showError("Move File", "Must be within a folder as a destination");
		}
	}

	handleCopy() {
		const { copyInfo } = this.state;
		const { hierarchy } = this.props;
		if (hierarchy.type === "folder") {
			if (copyInfo.origin.type === "file") {
				const destinationPath = _.concat(hierarchy.path, copyInfo.origin.fileName).join("/");
				copyFile(copyInfo.origin.guid, destinationPath)
					.then(this.handleCancelCopy)
					.catch((err) => showError("Copy File", `Failed to copy file ${copyInfo.origin.guid} to ${destinationPath}, reason: ${err}`));
			} else {
				const destinationPath = _.concat(hierarchy.path, copyInfo.origin.name).join("/");
				copyFolder(copyInfo.origin, destinationPath)
					.then(this.handleCancelCopy)
					.catch((err) => showError("Copy Folder", `Failed to copy folder ${copyInfo.origin.guid} to ${destinationPath}, reason: ${err}`));
			}
		} else {
			showError("Copy File", "Must be within a folder as a destination");
		}
	}

	handleShowCreateFolderModal() {
		this.setState({ showCreateFolderModal: true });
	}
	handleHideCreateFolderModal() {
		this.setState({ showCreateFolderModal: false });
	}
	handleCancelAddFolder() {
		this.handleHideCreateFolderModal();
		this.setState({ createFolder: null });
	}

	handleChangeCreateFolderName(e) {
		let name = e.target.value;
		let validationError = null;
		let validationState = "success";
		if (name && _.indexOf(RESERVED_FOLDER_NAMES, _.toLower(name)) !== -1) {
			validationState = "error";
			validationError = `This is a reserved name, unable to name folder '${name}'`;
			name = null;
		}
		this.setState({
			createFolder: _.assign({}, this.state.createFolder, {
				name,
				validationState,
				validationError
			})
		});
	}

	handleAddFolder() {
		const { createFolder: createFolderInfo } = this.state;
		const { hierarchy } = this.props;

		if (hierarchy.type === "folder") {
			createFolder(`${hierarchy && hierarchy.path ? hierarchy.path.join("/") + "/" : ""}${createFolderInfo.name}/`)
				.then(this.handleCancelAddFolder)
				.catch((err) => showError("Create Folder", "An error occurred while attempting to create the folder. Error: " + err));
		} else {
			showError("Create Folder", "Must select a folder to create a new folder in.");
		}
	}

	getPastedClipboardDefaults(text = "") {
		const trimmedText = text.trim();
		if (trimmedText) {
			try {
				const parsedJson = JSON.parse(trimmedText);
				return {
					fileName: "clipboard.json",
					content: JSON.stringify(parsedJson, null, 2),
					contentType: "application/json"
				};
			} catch (_err) {
				// Plain text clipboard content is still useful as a Drive file.
			}
		}

		return {
			fileName: "clipboard.txt",
			content: text,
			contentType: "text/plain"
		};
	}

	isPasteClipboardImageContentType(contentType = "") {
		return `${contentType || ""}`.toLowerCase().indexOf("image/") === 0;
	}

	getPasteClipboardExtensionForContentType(contentType = "") {
		const normalizedContentType = `${contentType || ""}`.toLowerCase();
		if (normalizedContentType === "application/json") {
			return "json";
		}
		if (normalizedContentType === "image/jpeg" || normalizedContentType === "image/jpg") {
			return "jpg";
		}
		if (normalizedContentType === "image/gif") {
			return "gif";
		}
		if (normalizedContentType === "image/webp") {
			return "webp";
		}
		if (normalizedContentType === "image/bmp") {
			return "bmp";
		}
		if (normalizedContentType === "image/svg+xml") {
			return "svg";
		}
		if (this.isPasteClipboardImageContentType(normalizedContentType)) {
			return "png";
		}
		return "txt";
	}

	getDefaultPastedClipboardImageFileName(file = null) {
		const contentType = `${file && file.type ? file.type : "image/png"}`.trim() || "image/png";
		const extension = this.getPasteClipboardExtensionForContentType(contentType);
		const fileName = `${file && file.name ? file.name : ""}`.trim();
		if (
			fileName &&
			!/^(image|clipboard-image)\.(png|jpe?g|gif|webp|bmp|svg)$/i.test(fileName)
		) {
			return fileName;
		}
		return generatePastedImageFileName(extension);
	}

	normalizePastedClipboardFileName(fileName, contentType) {
		const name = `${fileName || ""}`.trim();
		if (_.isEmpty(name)) {
			return "";
		}

		const hasExtension = /\.[^/.\\]+$/.test(name);
		if (hasExtension) {
			return name;
		}

		return `${name}.${this.getPasteClipboardExtensionForContentType(contentType)}`;
	}

	validatePastedClipboardFileName(fileName) {
		const normalizedName = this.normalizePastedClipboardFileName(fileName, this.state.pasteClipboardContentType);
		if (_.isEmpty(normalizedName)) {
			return "Enter a file name.";
		}
		if (/[\\/]/.test(normalizedName)) {
			return "File name cannot contain slashes.";
		}
		return null;
	}

	hasPastedClipboardPayload() {
		return !!this.state.pasteClipboardFile || !_.isEmpty(`${this.state.pasteClipboardText || ""}`);
	}

	revokePasteClipboardPreviewUrl() {
		if (this.state.pasteClipboardPreviewUrl && typeof URL !== "undefined" && URL.revokeObjectURL) {
			URL.revokeObjectURL(this.state.pasteClipboardPreviewUrl);
		}
	}

	focusPasteClipboardTarget() {
		setTimeout(() => {
			const target = this.pasteClipboardTarget && this.pasteClipboardTarget.current;
			if (target && typeof target.focus === "function") {
				target.focus();
			}
		});
	}

	openPastedClipboardFile(file) {
		if (!file || !this.isPasteClipboardImageContentType(file.type)) {
			return false;
		}

		this.revokePasteClipboardPreviewUrl();
		const contentType = `${file.type || "image/png"}`.trim() || "image/png";
		const fileName = this.normalizePastedClipboardFileName(this.getDefaultPastedClipboardImageFileName(file), contentType);
		const previewUrl = typeof URL !== "undefined" && URL.createObjectURL ? URL.createObjectURL(file) : "";
		this.setState({
			showPasteClipboardModal: true,
			pasteClipboardFileName: fileName,
			pasteClipboardText: "",
			pasteClipboardContentType: contentType,
			pasteClipboardFile: file,
			pasteClipboardPreviewUrl: previewUrl,
			pasteClipboardWaitingForPaste: false,
			pasteClipboardPasteError: "",
			pasteClipboardSaving: false
		});
		return true;
	}

	openPastedClipboardText(text = "") {
		this.revokePasteClipboardPreviewUrl();
		const defaults = this.getPastedClipboardDefaults(text);
		this.setState({
			showPasteClipboardModal: true,
			pasteClipboardFileName: defaults.fileName,
			pasteClipboardText: defaults.content,
			pasteClipboardContentType: defaults.contentType,
			pasteClipboardFile: null,
			pasteClipboardPreviewUrl: "",
			pasteClipboardWaitingForPaste: false,
			pasteClipboardPasteError: "",
			pasteClipboardSaving: false
		});
	}

	openPasteClipboardWaitingModal() {
		this.revokePasteClipboardPreviewUrl();
		this.setState({
			showPasteClipboardModal: true,
			pasteClipboardFileName: "",
			pasteClipboardText: "",
			pasteClipboardContentType: "text/plain",
			pasteClipboardFile: null,
			pasteClipboardPreviewUrl: "",
			pasteClipboardWaitingForPaste: true,
			pasteClipboardPasteError: "",
			pasteClipboardSaving: false
		}, this.focusPasteClipboardTarget);
	}

	handlePasteClipboardEvent(event) {
		if (!this.state.showPasteClipboardModal || this.state.pasteClipboardSaving) {
			return;
		}

		const targetId = `${event && event.target && event.target.id ? event.target.id : ""}`;
		if (targetId === "drive-paste-clipboard-file-name") {
			return;
		}

		const clipboard = readPasteEventContents(event);
		const imageFile = Array.isArray(clipboard.files)
			? clipboard.files.find((file) => file && this.isPasteClipboardImageContentType(file.type))
			: null;
		if (imageFile) {
			event.preventDefault();
			this.openPastedClipboardFile(imageFile);
			return;
		}

		if (!_.isEmpty(`${clipboard.text || ""}`)) {
			event.preventDefault();
			this.openPastedClipboardText(clipboard.text);
			return;
		}

		this.setState({
			pasteClipboardPasteError: "No image or text data was found in the pasted clipboard content."
		});
	}

	addPasteClipboardDocumentListener() {
		if (this.pasteClipboardDocumentListening || typeof document === "undefined") {
			return;
		}
		document.addEventListener("paste", this.handlePasteClipboardEvent);
		this.pasteClipboardDocumentListening = true;
	}

	removePasteClipboardDocumentListener() {
		if (!this.pasteClipboardDocumentListening || typeof document === "undefined") {
			return;
		}
		document.removeEventListener("paste", this.handlePasteClipboardEvent);
		this.pasteClipboardDocumentListening = false;
	}

	async handleShowPasteClipboardModal() {
		const { hierarchy } = this.props;
		if (!hierarchy || hierarchy.type !== "folder" || (hierarchy.hasOwnProperty("allowCreate") && !hierarchy.allowCreate)) {
			showError("Paste Clipboard", "Select a folder that allows new files before pasting clipboard content.");
			return;
		}

		const clipboard = await readClipboardContents();
		const imageFile = Array.isArray(clipboard.files)
			? clipboard.files.find((file) => file && this.isPasteClipboardImageContentType(file.type))
			: null;
		if (imageFile) {
			this.openPastedClipboardFile(imageFile);
			return;
		}

		if (!_.isEmpty(`${clipboard.text || ""}`)) {
			this.openPastedClipboardText(clipboard.text);
			return;
		}

		this.openPasteClipboardWaitingModal();
	}

	handleHidePasteClipboardModal() {
		if (this.state.pasteClipboardSaving) {
			return;
		}

		this.removePasteClipboardDocumentListener();
		this.revokePasteClipboardPreviewUrl();
		this.setState({
			showPasteClipboardModal: false,
			pasteClipboardFileName: "",
			pasteClipboardText: "",
			pasteClipboardContentType: "text/plain",
			pasteClipboardFile: null,
			pasteClipboardPreviewUrl: "",
			pasteClipboardWaitingForPaste: false,
			pasteClipboardPasteError: "",
			pasteClipboardSaving: false
		});
	}

	handleChangePasteClipboardFileName(event) {
		this.setState({ pasteClipboardFileName: event.target.value });
	}

	handleCreatePastedClipboardFile() {
		const { hierarchy } = this.props;
		const { pasteClipboardFileName, pasteClipboardText, pasteClipboardContentType, pasteClipboardFile, pasteClipboardSaving } = this.state;
		if (pasteClipboardSaving) {
			return;
		}

		const validationError = this.validatePastedClipboardFileName(pasteClipboardFileName);
		if (validationError) {
			showError("Paste Clipboard", validationError);
			return;
		}
		if (!hierarchy || hierarchy.type !== "folder") {
			showError("Paste Clipboard", "Select a folder before creating the pasted file.");
			return;
		}
		if (!pasteClipboardFile && _.isEmpty(`${pasteClipboardText || ""}`)) {
			showError("Paste Clipboard", "Paste image or text content before creating the file.");
			return;
		}

		const fileName = this.normalizePastedClipboardFileName(pasteClipboardFileName, pasteClipboardContentType);
		const folderPath = hierarchy.path ? hierarchy.path.join("/") : "";
		const path = folderPath ? `${folderPath}/${fileName}` : fileName;
		const uploadPromise = pasteClipboardFile
			? uploadFile(folderPath, pasteClipboardFile, null, false, {
				fileName,
				metaData: {
					type: this.isPasteClipboardImageContentType(pasteClipboardContentType) ? "image" : "file",
					contentType: pasteClipboardContentType
				}
			})
			: uploadContent(path, pasteClipboardText, pasteClipboardContentType);

		this.setState({ pasteClipboardSaving: true });
		uploadPromise
			.then(() => {
				this.removePasteClipboardDocumentListener();
				this.revokePasteClipboardPreviewUrl();
				this.setState({
					showPasteClipboardModal: false,
					pasteClipboardFileName: "",
					pasteClipboardText: "",
					pasteClipboardContentType: "text/plain",
					pasteClipboardFile: null,
					pasteClipboardPreviewUrl: "",
					pasteClipboardWaitingForPaste: false,
					pasteClipboardPasteError: "",
					pasteClipboardSaving: false
				});
				showSuccessToast(`Created ${fileName}`);
			})
			.catch((err) => {
				this.setState({ pasteClipboardSaving: false });
				showError("Paste Clipboard", `Failed to create ${fileName}. ${err}`);
			});
	}

	clearUploadInputs() {
		["drive-upload", "drive-folder-upload"].forEach((id) => {
			const input = document.getElementById(id);
			if (input) {
				input.value = "";
			}
		});
	}

	handleSelectUploadFile(event) {
		const inputEl = event?.target;
		const files = inputEl?.files;

		if (!files || files.length === 0) {
			showError("Upload File", "No files selected.");
			return;
		}

		const { hierarchy } = this.props;

		if (hierarchy.type !== "folder") {
			document.getElementById("drive-upload").value = "";
			showError("Upload File", "Need to select a folder and specify a file to upload");
			return;
		}

		const fileArray = Array.from(files);
			const hasVideoUploadPrompt = isMediaToolsEnabledForUrlParams(this.props.urlParams) && fileArray.some((file) => shouldPromptForVideoProcessing({
				file,
				showAdvanced: this.state.showAdvancedVideoOptions,
				skipOptimization: false
			}));

			if (hasVideoUploadPrompt) {
				this.queueVideoProcessingOptions(fileArray);
				return;
			}

		this.uploadSelectedFiles(fileArray);
	}

	handleShowUploadFolder() {
		const { hierarchy } = this.props;
		if (hierarchy.type !== "folder") {
			showError("Upload Folder", "Need to select a folder before uploading a folder.");
			return;
		}

		this.setState({
			showUploadFolderOptionsModal: true
		});
	}

	handleCloseUploadFolderOptionsModal() {
		this.clearUploadInputs();
		this.setState({
			showUploadFolderOptionsModal: false
		});
	}

	handleToggleUploadFolderRecursive(event) {
		this.setState({
			uploadFolderRecursive: !!_.get(event, "target.checked", false)
		});
	}

	handleBrowseUploadFolder() {
		const input = document.getElementById("drive-folder-upload");
		if (input) {
			input.click();
		}
	}

	handleSelectUploadFolder(event) {
		const files = _.get(event, "target.files", null);
		if (!files || files.length === 0) {
			showError("Upload Folder", "No folder files selected.");
			return;
		}

		const { hierarchy } = this.props;
		if (hierarchy.type !== "folder") {
			this.clearUploadInputs();
			showError("Upload Folder", "Need to select a folder before uploading a folder.");
			return;
		}

		const fileArray = Array.from(files);
		const filteredFiles = this.state.uploadFolderRecursive ? fileArray : fileArray.filter(isTopLevelFolderFile);
		if (filteredFiles.length === 0) {
			this.clearUploadInputs();
			showError("Upload Folder", "No files matched the selected folder options.");
			return;
		}

		const hasVideoUploadPrompt = isMediaToolsEnabledForUrlParams(this.props.urlParams) && filteredFiles.some((file) => shouldPromptForVideoProcessing({
			file,
			showAdvanced: this.state.showAdvancedVideoOptions,
			skipOptimization: false
		}));

		this.setState({
			showUploadFolderOptionsModal: false
		});

		if (hasVideoUploadPrompt) {
			this.queueVideoProcessingOptions(filteredFiles);
			return;
		}

		this.uploadSelectedFiles(filteredFiles);
	}

	handleToggleVideoAdvancedOptions(event) {
		const enabled = !!_.get(event, "target.checked", false);
		setVideoAdvancedOptionsEnabled(enabled);
		this.setState({
			showAdvancedVideoOptions: enabled
		});
	}

	async queueVideoProcessingOptions(fileArray = []) {
		let orientationSummary = getDefaultVideoOrientationSummary(Array.isArray(fileArray) ? fileArray.length : 0);
		try {
			orientationSummary = await summarizeVideoFileOrientations(fileArray);
		} catch (err) {
			console.warn("Unable to detect video orientation for upload options", err);
		}

		this.setState({
			showVideoProcessingOptionsModal: true,
			pendingUploadFiles: Array.from(fileArray || []),
			pendingUploadOrientationSummary: orientationSummary
		});
	}

	handleCloseVideoProcessingOptionsModal() {
		this.clearUploadInputs();
		this.setState({
			showVideoProcessingOptionsModal: false,
			pendingUploadFiles: [],
			pendingUploadOrientationSummary: getDefaultVideoOrientationSummary()
		});
	}

	handleContinueVideoProcessingOptionsModal(options) {
		const pendingUploadFiles = Array.isArray(this.state.pendingUploadFiles) ? this.state.pendingUploadFiles : [];
		setStoredVideoProcessingOptions(options);
		this.setState({
			showVideoProcessingOptionsModal: false,
			pendingUploadFiles: [],
			pendingUploadOrientationSummary: getDefaultVideoOrientationSummary()
		}, () => {
			if (pendingUploadFiles.length > 0) {
				this.uploadSelectedFiles(pendingUploadFiles, options);
			}
		});
	}

	getVideoProcessingOptionLabel(options = [], value = "", fallbackLabel = "") {
		const normalizedValue = `${value || ""}`.trim();
		const match = options.find((option) => option && option.value === normalizedValue);
		return match && match.label ? match.label : fallbackLabel;
	}

	describeVideoProcessingOptions(options = null) {
		if (!options || typeof options !== "object") {
			return "";
		}

		const details = [];
		const framingLabel = this.getVideoProcessingOptionLabel(VIDEO_FRAMING_PRESET_OPTIONS, options.framingPreset, "");
		if (framingLabel && options.framingPreset && options.framingPreset !== "source") {
			details.push(framingLabel);
		}

		const resizeLabel = this.getVideoProcessingOptionLabel(VIDEO_RESIZE_PRESET_OPTIONS, options.resizePreset, "");
		if (resizeLabel && options.resizePreset && options.resizePreset !== "source") {
			details.push(resizeLabel);
		}

		const styleFilterLabel = this.getVideoProcessingOptionLabel(VIDEO_STYLE_FILTER_PRESET_OPTIONS, options.styleFilterPreset, "");
		if (styleFilterLabel && options.styleFilterPreset && options.styleFilterPreset !== "none") {
			details.push(styleFilterLabel);
		}

		const rotationLabel = this.getVideoProcessingOptionLabel(VIDEO_ROTATION_PRESET_OPTIONS, options.rotationPreset, "");
		if (rotationLabel && options.rotationPreset && options.rotationPreset !== "source") {
			details.push(rotationLabel);
		}

		const audioLabel = this.getVideoProcessingOptionLabel(VIDEO_AUDIO_PRESET_OPTIONS, options.audioPreset, "");
		if (audioLabel && options.audioPreset && options.audioPreset !== "keep") {
			details.push(audioLabel);
		}

		const toneMapLabel = this.getVideoProcessingOptionLabel(VIDEO_TONE_MAP_PRESET_OPTIONS, options.hdrToneMapPreset, "");
		if (toneMapLabel) {
			details.push(toneMapLabel);
		}

		if (Number(options.trimStartSeconds) > 0 || Number(options.trimDurationSeconds) > 0) {
			details.push(`Trim ${Number(options.trimStartSeconds || 0).toFixed(1)}s${Number(options.trimDurationSeconds) > 0 ? ` + ${Number(options.trimDurationSeconds).toFixed(1)}s` : " to end"}`);
		}

		if (options.createThumbnailArtifact === true) {
			details.push("Create JPEG thumbnail artifact");
			if (Number(options.thumbnailFrameSeconds) > 0) {
				details.push(`Thumbnail at ${Number(options.thumbnailFrameSeconds).toFixed(1)}s`);
			}
		}

		return details.join(" | ");
	}

	registerPendingVideoProcessingUpload(uploadResponse, file, videoProcessingOptions = null) {
		if (!uploadResponse || !uploadResponse.guid || !isVideoFileCandidate(file)) {
			return;
		}

		const pendingEntry = {
			guid: uploadResponse.guid,
			path: uploadResponse.path || "",
			name: uploadResponse.fileName || file.name || "video",
			startRevision: Number(uploadResponse.revision) || 0,
			masterPath: `${uploadResponse.masterPath || ""}`.trim(),
			sourceFileName: `${file && file.name ? file.name : ""}`.trim(),
			description: this.describeVideoProcessingOptions(videoProcessingOptions),
			startedAt: Date.now()
		};

		this.setState((prevState) => ({
			processingUploads: {
				...(prevState.processingUploads || {}),
				[pendingEntry.guid]: pendingEntry
			}
		}), this.scheduleVideoProcessingPoll);
	}

	stopVideoProcessingPoll() {
		if (this.videoProcessingPollTimeout) {
			clearTimeout(this.videoProcessingPollTimeout);
			this.videoProcessingPollTimeout = null;
		}
		this.videoProcessingPollInFlight = false;
	}

	scheduleVideoProcessingPoll(delay = 4000) {
		const processingUploads = this.state.processingUploads && typeof this.state.processingUploads === "object"
			? this.state.processingUploads
			: {};
		if (_.isEmpty(processingUploads) || this.videoProcessingPollTimeout) {
			return;
		}

		this.videoProcessingPollTimeout = setTimeout(() => {
			this.videoProcessingPollTimeout = null;
			this.pollVideoProcessingUploads();
		}, delay);
	}

	async pollVideoProcessingUploads() {
		const processingUploads = this.state.processingUploads && typeof this.state.processingUploads === "object"
			? this.state.processingUploads
			: {};
		if (_.isEmpty(processingUploads) || this.videoProcessingPollInFlight) {
			return;
		}

		this.videoProcessingPollInFlight = true;
		try {
			await listDriveMap();
			const latestDriveObjects = getDriveObjectsAsMap();
			const nextProcessingUploads = { ...processingUploads };
			let completedCount = 0;

			_.forEach(processingUploads, (entry, guid) => {
				const latest = latestDriveObjects[guid];
				if (!latest) {
					return;
				}

				const latestRevision = Number(latest.revision) || 0;
				if (latestRevision > (Number(entry.startRevision) || 0)) {
					delete nextProcessingUploads[guid];
					completedCount++;
				}
			});

			if (completedCount > 0) {
				await listDriveForSelectedFolderSilently();
				const activeGuid = _.get(this.state, "cursor.guid") || this.props.lastActiveGuid || _.get(this.props, "activeCursor.guid");
				if (activeGuid) {
					setActiveTreeCursorForDriveGuid(activeGuid);
				}
			}

			this.setState({
				processingUploads: nextProcessingUploads
			}, () => {
				if (!_.isEmpty(this.state.processingUploads)) {
					this.scheduleVideoProcessingPoll();
				}
			});
		} catch (error) {
			console.warn("Unable to refresh Drive video processing status", error);
			this.scheduleVideoProcessingPoll(6000);
		} finally {
			this.videoProcessingPollInFlight = false;
		}
	}

	getPendingVideoProcessingForNode(node = null) {
		const guid = `${node && node.guid ? node.guid : ""}`.trim();
		if (!guid) {
			return null;
		}

		const processingUploads = this.state.processingUploads && typeof this.state.processingUploads === "object"
			? this.state.processingUploads
			: {};
		return processingUploads[guid] || null;
	}

	uploadSelectedFiles(fileArray = [], videoProcessingOptions = null) {
		const files = Array.isArray(fileArray) ? fileArray : [];

		if (files.length === 0) {
			showError("Upload File", "No files selected.");
			return;
		}

		const errors = [];
		const { hierarchy } = this.props;

		if (hierarchy.type !== "folder") {
			document.getElementById("drive-upload").value = "";
			showError("Upload File", "Need to select a folder and specify a file to upload");
			return;
		}

		showSpinner();

		refreshCredentials()
			.then(async () => {
				const MAX_CONCURRENT = 5;
				const path = hierarchy.path.join("/");

				const retryUpload = async (uploadFn, file, retries = 3, delay = 500) => {
					for (let i = 0; i < retries; i++) {
						try {
							return await uploadFn(file);
						} catch (err) {
							if (i === retries - 1) {
								throw err;
							}
							await new Promise((res) => setTimeout(res, delay));
						}
					}
				};

					const uploadFn = async (file) => {
						const uploadOverrides = {};
						if (videoProcessingOptions && isVideoFileCandidate(file)) {
							uploadOverrides.videoProcessingOptions = videoProcessingOptions;
							const outputFileName = `${videoProcessingOptions.outputFileName || ""}`.trim();
							if (files.length === 1 && outputFileName) {
								uploadOverrides.fileName = outputFileName;
							}
						}
						return uploadAndOptimizeMediaFile(path, file, null, false, uploadOverrides);
					};

				let index = 0;
				const workers = Array(MAX_CONCURRENT)
					.fill(null)
					.map(async () => {
						while (index < files.length) {
							const currentIndex = index++;
							const file = files[currentIndex];

							if (!file?.name) {
								errors.push("Upload File: there was an issue with a file.");
								continue;
							}

							try {
								const uploadResponse = await retryUpload(uploadFn, file);
								if (uploadResponse && isVideoFileCandidate(file)) {
									this.registerPendingVideoProcessingUpload(uploadResponse, file, videoProcessingOptions);
								}
							} catch (err) {
								errors.push(`Error uploading "${file.name}": ${err?.message || err}`);
							}
						}
					});

				await Promise.all(workers);

				this.clearUploadInputs();
				this.handleCancelUploadFile();
				await listDriveForSelectedFolderSilently();
			})
			.catch((err) => {
				showError("Upload File", "Failed to refresh credentials: " + err);
			})
			.finally(() => {
				hideSpinner();
				if (errors.length > 0) {
					showError("Upload File", errors.join("\n"));
				}
			});
	}

	handleShowUploadFile() {
		this.setState({ showUploadFileModal: true });
		document.getElementById("drive-upload").click();
	}
	handleHideUploadFile() {
		this.setState({ showUploadFileModal: false });
	}
	handleCancelUploadFile() {
		this.handleHideUploadFile();
		this.setState({ uploadFile: null });
	}

	handleCancel() {
		const { onCancel } = this.props;
		if (onCancel) { onCancel(); }
	}
	handleOk() {
		const { onOk } = this.props;
		const { cursor } = this.state;
		if (onOk) { onOk(cursor); }
	}

	handleRefresh() {
		this.setState({ refreshDisabled: true });
		refreshSelectedDriveFolder()
			.then(() => {
				const activeGuid = _.get(this.state, "cursor.guid") || this.props.lastActiveGuid || _.get(this.props, "activeCursor.guid");
				if (activeGuid) {
					setActiveTreeCursorForDriveGuid(activeGuid);
				}
				this.setState({ refreshDisabled: false });
			})
			.catch((err) =>
				showError("Refresh Drive", "An error occurred while attempting to refersh drive content:" + err, () =>
					this.setState({ refreshDisabled: false })
				)
			);
	}

	handleRefreshAll() {
		this.setState({ refreshDisabled: true });
		listDrive()
			.then(() => {
				const activeGuid = _.get(this.state, "cursor.guid") || this.props.lastActiveGuid || _.get(this.props, "activeCursor.guid");
				if (activeGuid) {
					setActiveTreeCursorForDriveGuid(activeGuid);
				}
				this.setState({ refreshDisabled: false });
			})
			.catch((err) =>
				showError("Refresh Drive", "An error occurred while attempting to refresh the entire drive:" + err, () =>
					this.setState({ refreshDisabled: false })
				)
			);
	}

	handleSwitchMode(targetMode) {
		handleSwitchHierarchyMode(targetMode);
	}

	handleDelete() {
		const { cursor } = this.state;
		const backupCursor = Object.assign({}, cursor);
		if (backupCursor.type === "folder") {
			showConfirm("Are you sure you want to delete the selected " + backupCursor.type + "?", "Delete", () => {
				this.setState({ cursor: null });
				deleteFolder(cursor)
					.then(() => {
						this.handleDeletedCursorSelection(backupCursor);
					})
					.catch((err) => showError("Delete", "Failed to delete " + cursor.type + ", reason:" + err));
			});
			return;
		}

		const relatedItems = this.collectRelatedGeneratedDriveObjects(backupCursor);
		if (_.isEmpty(relatedItems)) {
			showConfirm("Are you sure you want to delete the selected " + backupCursor.type + "?", "Delete", () => {
				this.setState({ cursor: null });
				deleteFile(backupCursor.guid)
					.then(() => {
						this.handleDeletedCursorSelection(backupCursor);
					})
					.catch((err) => {
						console.error(err);
						showError("Delete", "Failed to delete " + backupCursor.type + ", reason:" + err);
					});
			});
			return;
		}

		this.setState({
			showDeleteOptionsModal: true,
			deleteDialogTarget: backupCursor,
			deleteDialogRelatedItems: relatedItems,
			deleteDialogDeleteRelated: true
		});
	}

	handleDeletedCursorSelection(backupCursor = null) {
		if (backupCursor?.type === "file" && this.props.onFileSelected) {
			this.props.onFileSelected(null);
		} else if (backupCursor?.type === "folder" && this.props.onFolderSelected) {
			this.props.onFolderSelected(null);
		} else if (this.props.onItemSelected) {
			this.props.onItemSelected(null);
		}
	}

	handleCloseDeleteOptionsModal() {
		this.setState({
			showDeleteOptionsModal: false,
			deleteDialogTarget: null,
			deleteDialogRelatedItems: [],
			deleteDialogDeleteRelated: true
		});
	}

	handleToggleDeleteRelated(event) {
		this.setState({
			deleteDialogDeleteRelated: !!_.get(event, "target.checked", false)
		});
	}

	handleConfirmDeleteOptions() {
		const { deleteDialogTarget, deleteDialogRelatedItems, deleteDialogDeleteRelated } = this.state;
		if (!deleteDialogTarget || !deleteDialogTarget.guid) {
			this.handleCloseDeleteOptionsModal();
			return;
		}

		const relatedGuids = deleteDialogDeleteRelated
			? deleteDialogRelatedItems.map((item) => item && item.guid).filter(Boolean)
			: [];
		const objectGuids = _.uniq([deleteDialogTarget.guid, ...relatedGuids]);
		const targetPath = this.getCursorPath(deleteDialogTarget);
		this.setState({
			cursor: null,
			showDeleteOptionsModal: false,
			deleteDialogTarget: null,
			deleteDialogRelatedItems: [],
			deleteDialogDeleteRelated: true
		});

		const deletePromise = objectGuids.length > 1
			? deleteDriveObjectsBulk(objectGuids, targetPath)
			: deleteFile(deleteDialogTarget.guid);
		deletePromise.then(() => {
			this.handleDeletedCursorSelection(deleteDialogTarget);
		}).catch((err) => {
			console.error(err);
			showError("Delete", "Failed to delete file, reason:" + err);
		});
	}

	handleChangeNameRename(e) {
		this.setState({
			rename: _.assign({}, this.state.rename, { fileName: e.target.value })
		});
	}

	handleStartRename() {
		const { cursor } = this.state;
		this.setState({
			renaming: true,
			rename: _.assign({}, cursor, {
				fileName: cursor.name,
				fileNameNoExt: cursor.type === "folder" ? cursor.name : _.dropRight(cursor.name.split(".")).join("."),
				ext: cursor.type === "folder" ? null : _.last(cursor.name.split("."))
			})
		});
	}

	handleRename() {
		const { rename } = this.state;
		const { fileName } = rename;
		let destinationPath = null;
		if (rename.type === "folder") {
			destinationPath = _.dropRight(rename._path);
			destinationPath.push(fileName);
			moveFolder(rename, destinationPath.join("/"))
				.then((cursor) => {
					this.setState({ cursor });
					this.renderPreview();
					this.handleCancelRename();
				})
				.catch((err) => showError("Rename Folder", `Failed to rename folder ${rename.name} to ${fileName}, reason: ${err}`));
		} else if (rename.type === "file") {
			destinationPath = _.dropRight(rename._path);
			destinationPath.push(fileName);
			moveFile(rename.guid, destinationPath.join("/"))
				.then((cursor) => {
					this.setState({ cursor });
					this.renderPreview(cursor);
					this.handleCancelRename();
				})
				.catch((err) => showError("Rename File", `Failed to rename file ${rename.name} to ${fileName}, reason: ${err}`));
		} else {
			throw new Error("Must be a file or folder that is getting renamed");
		}
	}

	getDownloadFileName(cursor = null) {
		const target = cursor || this.state.cursor;
		if (!target) {
			return "download";
		}
		return target.name || target.fileName || _.last(this.getCursorPath(target).split("/")) || "download";
	}

	async fetchDownloadBlob(url) {
		const response = await request.get(url).responseType("blob");
		if (response.status >= 400) {
			throw new Error(`HTTP ${response.status}`);
		}
		return response.body;
	}

	isConstrainedMobileDownloadContext() {
		if (typeof navigator === "undefined") {
			return false;
		}
		const userAgent = navigator.userAgent || "";
		const platform = navigator.platform || "";
		return /iPhone|iPad|iPod/i.test(userAgent)
			|| (platform === "MacIntel" && navigator.maxTouchPoints > 1)
			|| !!(typeof window !== "undefined" && window.ReactNativeWebView);
	}

	openDownloadUrlInNewContext(url) {
		if (!url || typeof window === "undefined") {
			return false;
		}

		const bridgeMessage = JSON.stringify({ external_url_open: url });
		const bridgeTargets = [window.ReactNativeWebView, window.webView];
		for (const bridgeTarget of bridgeTargets) {
			if (bridgeTarget && typeof bridgeTarget.postMessage === "function") {
				try {
					bridgeTarget.postMessage(bridgeMessage);
					return true;
				} catch (err) {
					console.warn("Unable to request native URL open", err);
				}
			}
		}

		try {
			const openedWindow = window.open(url, "_blank", "noopener,noreferrer");
			if (openedWindow) {
				try {
					openedWindow.opener = null;
				} catch (_err) {
					// Some browsers disallow touching the opener for cross-origin windows.
				}
				return true;
			}
		} catch (err) {
			console.warn("window.open failed for Drive download URL", err);
		}

		if (typeof document !== "undefined" && document.body) {
			try {
				const link = document.createElement("a");
				link.href = url;
				link.target = "_blank";
				link.rel = "noopener noreferrer";
				link.style.display = "none";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				return true;
			} catch (err) {
				console.warn("Anchor fallback failed for Drive download URL", err);
			}
		}

		return false;
	}

	async saveDownloadedBlob(blob, fileName) {
		if (
			typeof navigator !== "undefined" &&
			typeof navigator.share === "function" &&
			typeof navigator.canShare === "function" &&
			typeof File === "function"
		) {
			const file = new File([blob], fileName, { type: blob.type || "application/octet-stream" });
			try {
				if (navigator.canShare({ files: [file] })) {
					await navigator.share({ files: [file], title: fileName });
					return;
				}
			} catch (err) {
				if (err && err.name === "AbortError") {
					return;
				}
			}
		}

		if (this.isConstrainedMobileDownloadContext()) {
			throw new Error("This mobile browser cannot save the file directly from Drive.");
		}

		saveAs(blob, fileName);
	}

	async handleDownloadFile() {
		const { cursor } = this.state;
		if (cursor) {
			const url = getUrlForResource(cursor);
			const fileName = this.getDownloadFileName(cursor);
			if (this.isConstrainedMobileDownloadContext()) {
				if (this.openDownloadUrlInNewContext(url)) {
					return;
				}
				showError(
					"Download File",
					`Unable to open ${fileName} in a separate browser view from this mobile browser.`
				);
				return;
			}

			try {
				const blob = await this.fetchDownloadBlob(url);
				await this.saveDownloadedBlob(blob, fileName);
			} catch (err) {
				saveAs(url, fileName);
			}
		}
	}

	handleCancelRename() {
		this.setState({ renaming: false, rename: {} });
	}

	normalizeTags(source) {
		if (!source) {
			return [];
		}

		if (Array.isArray(source)) {
			return source
				.map((entry) => {
					if (typeof entry === "string") {
						return entry.trim();
					}
					if (entry && typeof entry === "object") {
						const value = entry.label || entry.name || entry.Name || entry.tag || entry.Tag;
						return typeof value === "string" ? value.trim() : "";
					}
					return "";
				})
				.filter(Boolean);
		}

		if (typeof source === "string") {
			return source
				.split(/[,|\n]/)
				.map((entry) => entry.trim())
				.filter(Boolean);
		}

		if (source && typeof source === "object") {
			return Object.keys(source)
				.map((entry) => entry.trim())
				.filter(Boolean);
		}

		return [];
	}

	mergeUniqueTags(tags = []) {
		const seen = new Set();
		const result = [];

		tags.forEach((tag) => {
			const normalized = typeof tag === "string" ? tag.trim() : "";
			if (!normalized) {
				return;
			}
			const key = normalized.toLowerCase();
			if (seen.has(key)) {
				return;
			}
			seen.add(key);
			result.push(normalized);
		});

		return result;
	}

	cleanMetadataTitle(value) {
		if (typeof value !== "string") {
			return "";
		}
		let cleaned = value
			.replace(/\r\n/g, "\n")
			.replace(/\n/g, " ")
			.trim();
		if (cleaned.length > MAX_METADATA_TITLE_CHARS) {
			cleaned = cleaned.slice(0, MAX_METADATA_TITLE_CHARS).trim();
		}
		return cleaned;
	}

	cleanMetadataDescription(value) {
		if (typeof value !== "string") {
			return "";
		}
		let cleaned = value
			.replace(/\r\n/g, "\n")
			.trim();
		if (cleaned.length > MAX_METADATA_DESCRIPTION_CHARS) {
			cleaned = cleaned.slice(0, MAX_METADATA_DESCRIPTION_CHARS).trim();
		}
		return cleaned;
	}

	cleanMetadataTranscript(value) {
		if (typeof value !== "string") {
			return "";
		}
		let cleaned = value
			.replace(/\r\n/g, "\n")
			.trim();
		if (cleaned.length > MAX_METADATA_TRANSCRIPT_CHARS) {
			cleaned = cleaned.slice(0, MAX_METADATA_TRANSCRIPT_CHARS).trim();
		}
		return cleaned;
	}

	cleanMetadataTranscriptVtt(value) {
		if (typeof value !== "string") {
			return "";
		}
		let cleaned = value
			.replace(/\r\n/g, "\n")
			.trim();
		if (!cleaned) {
			return "";
		}
		const hasTimestamps = /-->/m.test(cleaned);
		if (hasTimestamps && !/^WEBVTT/i.test(cleaned)) {
			cleaned = `WEBVTT\n\n${cleaned}`;
		}
		if (cleaned.length > MAX_METADATA_TRANSCRIPT_VTT_CHARS) {
			cleaned = cleaned.slice(0, MAX_METADATA_TRANSCRIPT_VTT_CHARS).trim();
		}
		return cleaned;
	}

	isMetadataGenerationInProgress(field = "") {
		const current = `${this.state.metadataGeneratingField || ""}`;
		if (!field) {
			return current !== "";
		}
		return current === field;
	}

	getCursorPath(cursor = null) {
		const target = cursor || this.state.cursor;
		if (!target) {
			return "";
		}
		if (Array.isArray(target.path)) {
			return target.path.join("/");
		}
		if (typeof target.path === "string" && target.path.trim() !== "") {
			return target.path.trim();
		}
		if (typeof target.fullPath === "string" && target.fullPath.trim() !== "") {
			return target.fullPath.trim();
		}
		if (Array.isArray(target._path)) {
			return target._path.join("/");
		}
		return "";
	}

	getCursorMediaType(cursor = null) {
		const target = cursor || this.state.cursor;
		if (!target || !target.ext) {
			return "file";
		}
		try {
			return getMediaType(target.ext) || "file";
		} catch (_err) {
			return "file";
		}
	}

	getDriveObjectInfo(cursor = null) {
		const target = cursor || this.state.cursor;
		if (!target) {
			return null;
		}
		if (target.guid) {
			const driveObject = getDriveObjectsAsMap()?.[target.guid];
			if (driveObject) {
				return driveObject;
			}
		}
		return target;
	}

	buildGeneratedCompanionPathCandidates(cursor = null) {
		const s3Key = this.getCursorS3Key(cursor);
		if (!s3Key || s3Key.lastIndexOf(".") < 0) {
			return { transcriptionPaths: [], vttPaths: [], srtPaths: [] };
		}

		const basePathWithoutExt = s3Key.slice(0, s3Key.lastIndexOf("."));
		const transcriptionPath = `${basePathWithoutExt}-transcription.json`;
		const vttPath = `${basePathWithoutExt}-subtitles.vtt`;
		const srtPath = `${basePathWithoutExt}-subtitles.srt`;

		return {
			transcriptionPaths: this.createPathCandidateVariants(transcriptionPath),
			vttPaths: this.createPathCandidateVariants(vttPath),
			srtPaths: this.createPathCandidateVariants(srtPath)
		};
	}

	getDirectGeneratedDriveObjects(cursor = null, allDriveObjects = null) {
		const target = this.getDriveObjectInfo(cursor);
		if (!target || target.type !== "file") {
			return [];
		}

		const objects = Array.isArray(allDriveObjects) ? allDriveObjects : Object.values(getDriveObjectsAsMap() || {});
		const targetGuid = `${target.guid || ""}`.trim();
		const targetPath = this.normalizePathForLookup(this.getCursorPath(target));
		const targetMetaData = _.isPlainObject(target.metaData) ? target.metaData : {};
		const targetVideoRole = `${targetMetaData.videoAssetRole || ""}`.trim().toLowerCase();
		const derivedObjects = [];
		const seenGuids = new Set();
		const addCandidate = (candidate) => {
			if (!candidate || candidate.type !== "file" || !candidate.guid || candidate.guid === targetGuid || seenGuids.has(candidate.guid)) {
				return;
			}
			seenGuids.add(candidate.guid);
			derivedObjects.push(candidate);
		};

		objects.forEach((item) => {
			if (!item || item.type !== "file") {
				return;
			}
			const metaData = _.isPlainObject(item.metaData) ? item.metaData : {};
			const sourceVideoGuid = `${metaData.sourceVideoDriveObjectGuid || ""}`.trim();
			const sourceVideoPath = this.normalizePathForLookup(`${metaData.sourceVideoDrivePath || ""}`.trim());
			const masterVideoPath = this.normalizePathForLookup(`${metaData.masterVideoDrivePath || ""}`.trim());

			if (targetGuid && sourceVideoGuid && sourceVideoGuid === targetGuid) {
				addCandidate(item);
				return;
			}
			if (targetPath && sourceVideoPath && sourceVideoPath === targetPath) {
				addCandidate(item);
				return;
			}
			if (targetVideoRole === "master" && targetPath && masterVideoPath && masterVideoPath === targetPath) {
				addCandidate(item);
			}
		});

		const linkedMasterPath = `${targetMetaData.masterVideoDrivePath || ""}`.trim();
		if (linkedMasterPath) {
			addCandidate(this.resolveDriveObjectForPathCandidates(this.createPathCandidateVariants(linkedMasterPath)));
		}

		const { transcriptionPaths, vttPaths, srtPaths } = this.buildGeneratedCompanionPathCandidates(target);
		[
			this.resolveDriveObjectForPathCandidates(transcriptionPaths),
			this.resolveDriveObjectForPathCandidates(vttPaths),
			this.resolveDriveObjectForPathCandidates(srtPaths)
		].forEach(addCandidate);

		return derivedObjects;
	}

	collectRelatedGeneratedDriveObjects(cursor = null) {
		const root = this.getDriveObjectInfo(cursor);
		if (!root || root.type !== "file") {
			return [];
		}

		const allDriveObjects = Object.values(getDriveObjectsAsMap() || {});
		const queue = [root];
		const visitedGuids = new Set([`${root.guid || ""}`.trim()]);
		const related = [];

		while (queue.length > 0) {
			const current = queue.shift();
			const directChildren = this.getDirectGeneratedDriveObjects(current, allDriveObjects);
			directChildren.forEach((child) => {
				const childGuid = `${child && child.guid ? child.guid : ""}`.trim();
				if (!childGuid || visitedGuids.has(childGuid)) {
					return;
				}
				visitedGuids.add(childGuid);
				related.push(child);
				queue.push(child);
			});
		}

		return _.sortBy(related, [
			(item) => `${_.get(item, "metaData.derivedArtifact", "")}`.trim(),
			(item) => `${item.name || ""}`.toLowerCase()
		]);
	}

	getDeleteRelatedItemLabel(item = null) {
		if (!item) {
			return "";
		}
		const derivedArtifact = `${_.get(item, "metaData.derivedArtifact", "")}`.trim();
		const itemType = `${_.get(item, "metaData.type", "")}`.trim().toLowerCase();
		if (derivedArtifact === "video-master") {
			return "Master video";
		}
		if (derivedArtifact === "video-thumbnail") {
			return "Generated thumbnail";
		}
		if (derivedArtifact === "video-chunk") {
			return "Derived video chunk";
		}
		if (itemType === "ambifi/transcription") {
			return "Transcription JSON";
		}
		if (itemType === "ambifi/subtitles-vtt") {
			return "Subtitles VTT";
		}
		if (itemType === "ambifi/subtitles") {
			return "Subtitles SRT";
		}
		return "Generated companion";
	}

	getCursorS3Key(cursor = null) {
		const path = this.getCursorPath(cursor);
		if (!path) {
			return "";
		}

		const pathParts = path
			.trim()
			.replace(/^\/+/, "")
			.split("/")
			.filter(Boolean);
		if (pathParts.length < 2) {
			return path;
		}

		const rootSegment = pathParts[0];
		if (rootSegment !== "private" && rootSegment !== "public") {
			return path;
		}

		const hasOrgSegment = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(pathParts[1] || "");
		if (!hasOrgSegment) {
			const orgId = getOrgId();
			if (orgId) {
				pathParts.splice(1, 0, orgId);
			}
		}

		return pathParts.join("/");
	}

	createPathCandidateVariants(pathValue = "") {
		const variants = [];
		const pushVariant = (candidate) => {
			if (!candidate) {
				return;
			}
			const normalized = `${candidate}`.trim().replace(/^\/+/, "");
			if (!normalized || variants.includes(normalized)) {
				return;
			}
			variants.push(normalized);
		};

		const base = `${pathValue || ""}`.trim().replace(/^\/+/, "");
		if (!base) {
			return variants;
		}

		pushVariant(base);
		pushVariant(base.replace(/\s/g, "_"));

		const withoutOrg = base.replace(/^(public|private)\/[^/]+\//, "$1/");
		pushVariant(withoutOrg);
		pushVariant(withoutOrg.replace(/\s/g, "_"));

		return variants;
	}

	buildAwsTranscribeCompanionPathCandidates(cursor = null) {
		const s3Key = this.getCursorS3Key(cursor);
		if (!s3Key || s3Key.lastIndexOf(".") < 0) {
			return { transcriptionPaths: [], vttPaths: [] };
		}

		const basePathWithoutExt = s3Key.slice(0, s3Key.lastIndexOf("."));
		const transcriptionPath = `${basePathWithoutExt}-transcription.json`;
		const vttPath = `${basePathWithoutExt}-subtitles.vtt`;

		return {
			transcriptionPaths: this.createPathCandidateVariants(transcriptionPath),
			vttPaths: this.createPathCandidateVariants(vttPath)
		};
	}

	resolveDriveObjectForPathCandidates(pathCandidates = []) {
		const normalizedCandidates = pathCandidates
			.map((candidate) => `${candidate || ""}`.trim().replace(/^\/+/, ""))
			.filter(Boolean);
		if (!normalizedCandidates.length) {
			return null;
		}

		const normalizedLookup = new Set([
			...normalizedCandidates,
			...normalizedCandidates.map((candidate) => this.normalizePathForLookup(candidate))
		]);

		const driveObjectsAsMap = getDriveObjectsAsMap() || {};
		const driveObjects = Object.values(driveObjectsAsMap);
		for (let i = 0; i < driveObjects.length; i++) {
			const info = driveObjects[i];
			const rawInfoPath = Array.isArray(info?.path) ? info.path.join("/") : `${info?.path || ""}`;
			if (!rawInfoPath) {
				continue;
			}
			const normalizedInfoPath = rawInfoPath.trim().replace(/^\/+/, "");
			const lookupInfoPath = this.normalizePathForLookup(normalizedInfoPath);
			if (normalizedLookup.has(normalizedInfoPath) || normalizedLookup.has(lookupInfoPath)) {
				return info;
			}
		}

		const candidateNames = pathCandidates
			.map((candidate) => `${candidate}`.split("/").pop())
			.filter(Boolean);
		if (!candidateNames.length) {
			return null;
		}

		const children = Array.isArray(this.props?.hierarchy?.children) ? this.props.hierarchy.children : [];
		const byName = children.find((child) => child?.type === "file" && candidateNames.includes(child?.name));
		return byName || null;
	}

	extractTranscriptFromAwsTranscribeJson(jsonPayload) {
		if (!jsonPayload || typeof jsonPayload !== "object") {
			return "";
		}
		const direct = jsonPayload?.results?.transcripts?.[0]?.transcript;
		if (typeof direct === "string" && direct.trim() !== "") {
			return direct.trim();
		}
		return "";
	}

	extractTagsFromRekognitionPayload(payload) {
		if (!payload) {
			return [];
		}
		if (typeof payload === "string") {
			return this.mergeUniqueTags(this.normalizeTags(payload));
		}

		const tags = [];
		const addTag = (value) => {
			const normalized = this.cleanGeneratedTagCandidate(`${value || ""}`);
			if (normalized) {
				tags.push(normalized);
			}
		};

		(this.normalizeTags(payload.tags || []) || []).forEach(addTag);
		(this.normalizeTags(payload.rekognitionTags || []) || []).forEach(addTag);
		(this.normalizeTags(payload.openAiTags || []) || []).forEach(addTag);

		if (Array.isArray(payload.labels)) {
			payload.labels.forEach((labelEntry) => {
				if (typeof labelEntry === "string") {
					addTag(labelEntry);
					return;
				}
				if (labelEntry && typeof labelEntry === "object") {
					addTag(labelEntry.Name || labelEntry.name);
				}
			});
		}

		if (Array.isArray(payload.Labels)) {
			payload.Labels.forEach((labelEntry) => {
				if (labelEntry && typeof labelEntry === "object") {
					addTag(labelEntry.Name || labelEntry.name);
				}
			});
		}

		return this.mergeUniqueTags(tags).slice(0, 25);
	}

	extractAwsTranscribeVtt(payload) {
		if (!payload) {
			return "";
		}
		if (typeof payload === "string") {
			return /-->/m.test(payload) ? payload : "";
		}

		const candidates = [
			payload.vtt,
			payload.transcriptVtt,
			payload.transcript_vtt,
			payload.output_vtt,
			payload.outputVtt,
			payload.text
		];
		for (let i = 0; i < candidates.length; i++) {
			const candidate = candidates[i];
			if (typeof candidate === "string" && /-->/m.test(candidate)) {
				return candidate;
			}
		}

		return "";
	}

	extractAwsTranscribeText(payload) {
		if (!payload) {
			return "";
		}
		if (typeof payload === "string") {
			return payload;
		}

		const directText =
			payload.text ||
			payload.transcript ||
			payload.output_text ||
			payload.content ||
			payload?.results?.transcripts?.[0]?.transcript ||
			"";

		if (typeof directText === "string" && directText.trim() !== "") {
			return directText.trim();
		}

		return this.extractResponsesText(payload);
	}

	extractTranscriptFromVtt(vttValue = "") {
		const normalized = `${vttValue || ""}`.replace(/\r\n/g, "\n");
		if (!normalized.trim()) {
			return "";
		}

		const lines = normalized
			.split("\n")
			.map((line) => line.trim())
			.filter((line) => line !== "")
			.filter((line) => !/^WEBVTT$/i.test(line))
			.filter((line) => !/^NOTE\b/i.test(line))
			.filter((line) => !/^\d+$/.test(line))
			.filter((line) => !/^\d{1,2}:\d{2}(?::\d{2})?[.,]\d{3}\s+-->\s+\d{1,2}:\d{2}(?::\d{2})?[.,]\d{3}/.test(line));

		return lines.join(" ").replace(/\s+/g, " ").trim();
	}

	async fetchAwsTranscribeCompanionContent(cursor = null) {
		const { transcriptionPaths, vttPaths } = this.buildAwsTranscribeCompanionPathCandidates(cursor);
		const transcriptionObject = this.resolveDriveObjectForPathCandidates(transcriptionPaths);
		const vttObject = this.resolveDriveObjectForPathCandidates(vttPaths);

		let transcriptText = "";
		let transcriptVtt = "";

		if (transcriptionObject?.guid) {
			try {
				const transcriptionJson = await getContent(transcriptionObject.guid);
				transcriptText = this.cleanMetadataTranscript(this.extractTranscriptFromAwsTranscribeJson(transcriptionJson));
			} catch (err) {
				console.warn("Unable to load AWS transcription JSON sidecar:", err?.message || err);
			}
		}

		if (vttObject?.guid) {
			try {
				const rawVtt = await getContentRaw(vttObject.guid);
				transcriptVtt = this.cleanMetadataTranscriptVtt(rawVtt);
				if (!transcriptText && transcriptVtt) {
					transcriptText = this.cleanMetadataTranscript(this.extractTranscriptFromVtt(transcriptVtt));
				}
			} catch (err) {
				console.warn("Unable to load AWS subtitles VTT sidecar:", err?.message || err);
			}
		}

		return {
			transcriptText,
			transcriptVtt,
			transcriptionObject,
			vttObject,
			transcriptionPaths,
			vttPaths
		};
	}

	extractResponsesText(payload) {
		if (!payload) {
			return "";
		}
		if (typeof payload === "string") {
			return payload;
		}
		if (typeof payload.output_text === "string" && payload.output_text.trim() !== "") {
			return payload.output_text;
		}
		if (payload.response && typeof payload.response.output_text === "string" && payload.response.output_text.trim() !== "") {
			return payload.response.output_text;
		}
		if (typeof payload.text === "string" && payload.text.trim() !== "") {
			return payload.text;
		}

		const readOutputArray = (arr) => {
			if (!Array.isArray(arr)) {
				return "";
			}
			const parts = [];
			arr.forEach((entry) => {
				if (!entry) {
					return;
				}
				if (entry.type === "message" && Array.isArray(entry.content)) {
					entry.content.forEach((contentPart) => {
						if (!contentPart) {
							return;
						}
						if (typeof contentPart.text === "string" && contentPart.text.trim() !== "") {
							parts.push(contentPart.text);
							return;
						}
						if (typeof contentPart.value === "string" && contentPart.value.trim() !== "") {
							parts.push(contentPart.value);
						}
					});
					return;
				}
				if (typeof entry.text === "string" && entry.text.trim() !== "") {
					parts.push(entry.text);
				}
			});
			return parts.join("").trim();
		};

		const responseArrayText = readOutputArray(payload.output || payload.response?.output);
		if (responseArrayText) {
			return responseArrayText;
		}

		return "";
	}

	cleanGeneratedTagCandidate(value) {
		if (typeof value !== "string") {
			return "";
		}

		let cleaned = value
			.replace(/^[-*•]\s+/, "")
			.replace(/^\d+\.\s+/, "")
			.replace(/^tags?\s*:\s*/i, "")
			.replace(/^["'`]+|["'`]+$/g, "")
			.replace(/\s+/g, " ")
			.trim();

		cleaned = cleaned.replace(/[;,.\-:]+$/g, "").trim();
		if (!cleaned) {
			return "";
		}
		if (cleaned.length > 80) {
			return "";
		}
		return cleaned;
	}

	parseGeneratedTags(responseText = "") {
		if (typeof responseText !== "string" || responseText.trim() === "") {
			return [];
		}

		const tags = [];
		const addTags = (entries = []) => {
			entries.forEach((entry) => {
				const cleaned = this.cleanGeneratedTagCandidate(entry);
				if (cleaned) {
					tags.push(cleaned);
				}
			});
		};

		const normalizedText = responseText
			.replace(/\r\n/g, "\n")
			.replace(/```[a-zA-Z0-9_-]*\n?/g, "")
			.replace(/```/g, "")
			.trim();
		const lines = normalizedText
			.split("\n")
			.map((line) => line.trim())
			.filter(Boolean);

		for (let i = 0; i < Math.min(lines.length, 12); i++) {
			const line = lines[i]
				.replace(/^assistant:\s*/i, "")
				.replace(/^tags?\s*:\s*/i, "");
			if (line.indexOf(",") > -1) {
				addTags(line.split(","));
				if (tags.length >= 3) {
					break;
				}
			}
		}

		if (tags.length === 0) {
			const bulletLines = lines.filter((line) => /^([-*•]|\d+\.)\s+/.test(line));
			if (bulletLines.length > 0) {
				addTags(bulletLines);
			}
		}

		if (tags.length === 0 && lines.length > 0) {
			addTags(lines[0].split(","));
		}

		return this.mergeUniqueTags(tags).slice(0, 25);
	}

	buildMetadataGenerationContext() {
		const {
			cursor,
			metadataEditorTitle,
			metadataEditorDescription,
			metadataEditorTranscript,
			metadataEditorTranscriptVtt,
			tagsEditorPrimary
		} = this.state;
		const mediaType = this.getCursorMediaType(cursor);
		const path = this.getCursorPath(cursor);
		const title = this.cleanMetadataTitle(metadataEditorTitle || "");
		const description = this.cleanMetadataDescription(metadataEditorDescription || "");
		const transcript = this.cleanMetadataTranscript(metadataEditorTranscript || "");
		const transcriptVtt = this.cleanMetadataTranscriptVtt(metadataEditorTranscriptVtt || "");
		const tags = this.mergeUniqueTags(tagsEditorPrimary || []);

		const contextParts = [
			`File name: ${cursor?.name || "(unknown)"}`,
			`Media type: ${mediaType}`,
			`Path: ${path || "(unknown)"}`,
			`Current title: ${title || "(none)"}`,
			`Current description: ${description || "(none)"}`,
			`Current transcript available: ${transcript ? "yes" : "no"}`,
			`Current timed transcript (VTT) available: ${transcriptVtt ? "yes" : "no"}`,
			`Current tags: ${tags.length ? tags.join(", ") : "(none)"}`
		];

		if (transcript) {
			const transcriptSnippet = transcript.length > 3000 ? `${transcript.slice(0, 3000)}\n\n[Transcript truncated.]` : transcript;
			contextParts.push(`Transcript snippet:\n${transcriptSnippet}`);
		}

		return contextParts.join("\n");
	}

	buildMetadataImageContextHints() {
		const { cursor } = this.state;
		const fileName = `${cursor?.name || ""}`.trim();
		const rawPath = `${this.getCursorPath(cursor) || ""}`.trim();
		const pathParts = rawPath
			.split("/")
			.map((part) => part.trim())
			.filter(Boolean)
			.filter((part, index) => {
				if ((part === "public" || part === "private") && index === 0) {
					return false;
				}
				return !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(part);
			});
		const folderParts = fileName
			? pathParts.filter((part) => part.toLowerCase() !== fileName.toLowerCase())
			: pathParts;
		const contextualFolderHints = folderParts.slice(-4);
		const contextParts = [];

		if (fileName) {
			contextParts.push(`File name hint: ${fileName}`);
		}
		if (rawPath) {
			contextParts.push(`Drive path hint: ${rawPath}`);
		}
		if (contextualFolderHints.length > 0) {
			contextParts.push(`Useful folder context: ${contextualFolderHints.join(" | ")}`);
		}

		return contextParts.join("\n");
	}

	async runMetadataResponsesPrompt(promptText) {
		const requestBody = {
			model: "gpt-5.4",
			input: [
				{
					role: "user",
					content: [{ type: "input_text", text: promptText }]
				}
			]
		};
		const payload = await getResponsesCreateLambda(JSON.stringify(requestBody), { showAlert: false });
		return this.extractResponsesText(payload);
	}

	handleMetadataTranscriptProviderChange(event) {
		this.setState({ metadataTranscriptProvider: event?.target?.value || TRANSCRIPT_PROVIDER_AWS_TRANSCRIBE });
	}

	handleMetadataTagsProviderChange(event) {
		this.setState({ metadataTagsProvider: event?.target?.value || TAGS_PROVIDER_OPENAI });
	}

	async handleGenerateMetadataTitle() {
		const { cursor } = this.state;
		if (!cursor || cursor.type !== "file") {
			showError("Metadata", "Select a file before generating a title.");
			return;
		}

		this.setState({ metadataGeneratingField: "title" });
		try {
			const prompt = [
				"You are generating metadata for a Drive asset.",
				"Return only a concise title (no label, no quotes, no markdown), max 120 characters.",
				"",
				this.buildMetadataGenerationContext()
			].join("\n");
			const responseText = await this.runMetadataResponsesPrompt(prompt);
			const title = this.cleanMetadataTitle(responseText);
			if (!title) {
				throw new Error("Generation returned an empty title.");
			}
			this.setState({ metadataEditorTitle: title });
		} catch (err) {
			showError("Generate Title", err?.message || `${err}`);
		} finally {
			this.setState({ metadataGeneratingField: "" });
		}
	}

	async handleGenerateMetadataDescription() {
		const { cursor } = this.state;
		if (!cursor || cursor.type !== "file") {
			showError("Metadata", "Select a file before generating a description.");
			return;
		}

		this.setState({ metadataGeneratingField: "description" });
		try {
			const mediaType = this.getCursorMediaType(cursor);
			let responseText = "";

			if (mediaType === "image") {
				const s3Key = this.getCursorS3Key(cursor);
				if (!s3Key) {
					throw new Error("Missing S3 key for selected image.");
				}
				const imageContextHints = this.buildMetadataImageContextHints();
				responseText = await getImageDescriptionsLambda(JSON.stringify({
					bucket: env.s3.assetsBucket,
					key: s3Key,
					fileName: cursor.name || "",
					mediaType,
					prompt: [
						"Describe this specific image in one concise searchable description for asset metadata.",
						"Use the image itself as the primary evidence.",
						"Use file name and Drive path only as secondary context when they provide useful identifiers such as community, model, room, or lot ID.",
						"Do not invent details that are not visible in the image or clearly supported by the path context.",
						"Return only the description, max 600 characters.",
						"",
						imageContextHints
					].filter(Boolean).join("\n")
				}));
			} else {
				const prompt = [
					"You are generating metadata for a Drive asset.",
					"Return only one concise description for search/discovery, max 600 characters.",
					"No markdown, no headings, no source citations.",
					"",
					this.buildMetadataGenerationContext()
				].join("\n");
				responseText = await this.runMetadataResponsesPrompt(prompt);
			}

			const description = this.cleanMetadataDescription(responseText);
			if (!description) {
				throw new Error("Generation returned an empty description.");
			}
			this.setState({ metadataEditorDescription: description });
		} catch (err) {
			showError("Generate Description", err?.message || `${err}`);
		} finally {
			this.setState({ metadataGeneratingField: "" });
		}
	}

	async handleGenerateMetadataTranscript() {
		const { cursor, metadataTranscriptProvider } = this.state;
		if (!cursor || cursor.type !== "file") {
			showError("Metadata", "Select a file before generating transcript/content text.");
			return;
		}

		this.setState({ metadataGeneratingField: "transcript" });
		try {
			const mediaType = this.getCursorMediaType(cursor);
			if (metadataTranscriptProvider === TRANSCRIPT_PROVIDER_AWS_TRANSCRIBE) {
				if (mediaType !== "audio" && mediaType !== "video") {
					throw new Error("AWS Transcribe generation is only supported for audio/video files.");
				}

				const s3Key = this.getCursorS3Key(cursor);
				if (!s3Key) {
					throw new Error("Missing S3 key for selected file.");
				}

				let transcriptText = "";
				let transcriptVtt = "";
				let generationError = null;

				try {
					const awsResponse = await getAwsTranscribeLambda(JSON.stringify({
						bucket: env.s3.assetsBucket,
						key: s3Key,
						fileName: cursor.name || "",
						mediaType,
						response_format: "text"
					}), { showAlert: false });

					transcriptText = this.cleanMetadataTranscript(this.extractAwsTranscribeText(awsResponse));
					transcriptVtt = this.cleanMetadataTranscriptVtt(this.extractAwsTranscribeVtt(awsResponse));
					if (!transcriptText && transcriptVtt) {
						transcriptText = this.cleanMetadataTranscript(this.extractTranscriptFromVtt(transcriptVtt));
					}
				} catch (err) {
					generationError = err;
				}

				if (!transcriptText) {
					const awsArtifacts = await this.fetchAwsTranscribeCompanionContent(cursor);
					transcriptText = awsArtifacts.transcriptText;
					transcriptVtt = transcriptVtt || awsArtifacts.transcriptVtt;
					if (!transcriptText && transcriptVtt) {
						transcriptText = this.cleanMetadataTranscript(this.extractTranscriptFromVtt(transcriptVtt));
					}
				}

				if (!transcriptText) {
					if (generationError) {
						throw new Error(`AWS Transcribe generation failed: ${generationError?.message || generationError}`);
					}
					throw new Error(
						"No AWS transcription generated and no sidecar found. Expected transcription output or companion '-transcription.json' near this asset."
					);
				}

				const updates = { metadataEditorTranscript: transcriptText };
				if (transcriptVtt) {
					updates.metadataEditorTranscriptVtt = transcriptVtt;
				}
				this.setState(updates);
				return;
			}

			const s3Key = this.getCursorS3Key(cursor);
			if (!s3Key) {
				throw new Error("Missing S3 key for selected file.");
			}

			let transcriptText = "";
			if (mediaType === "audio" || mediaType === "video") {
				const response = await getAudioTranscriptionsLambda(JSON.stringify({
					bucket: env.s3.assetsBucket,
					key: s3Key,
					fileName: cursor.name || "",
					mediaType,
					prompt: `Transcribe this ${mediaType} into plain text with useful section breaks.`
				}));
				transcriptText = this.extractResponsesText(response);
			} else if (mediaType === "image") {
				const response = await getImageDescriptionsLambda(JSON.stringify({
					bucket: env.s3.assetsBucket,
					key: s3Key,
					fileName: cursor.name || "",
					mediaType,
					prompt: "Describe this image in plain text for accessibility and search."
				}));
				transcriptText = this.extractResponsesText(response);
			} else if (mediaType === "pdf") {
				const response = await getPdfResponsesLambda(JSON.stringify({
					bucket: env.s3.assetsBucket,
					key: s3Key,
					fileName: cursor.name || "",
					model: "gpt-5.4",
					prompt: "Summarize this selected PDF into clean, practical sections for searchable content metadata."
				}), { showAlert: false });
				transcriptText = this.extractResponsesText(response);
			} else {
				const prompt = [
					"You are generating a long-form content text field for a Drive asset.",
					"For non-audio/video files, produce a concise content representation based on available metadata.",
					"No markdown tables. No source citations.",
					"",
					this.buildMetadataGenerationContext()
				].join("\n");
				transcriptText = await this.runMetadataResponsesPrompt(prompt);
			}

			const cleanedTranscript = this.cleanMetadataTranscript(transcriptText);
			if (!cleanedTranscript) {
				throw new Error("Generation returned empty transcript/content text.");
			}
			this.setState({ metadataEditorTranscript: cleanedTranscript });
		} catch (err) {
			showError("Generate Transcript", err?.message || `${err}`);
		} finally {
			this.setState({ metadataGeneratingField: "" });
		}
	}

	async handleGenerateMetadataTranscriptVtt() {
		const { cursor, metadataTranscriptProvider } = this.state;
		if (!cursor || cursor.type !== "file") {
			showError("Generate VTT", "Select a file before generating timed transcript.");
			return;
		}

		this.setState({ metadataGeneratingField: "transcriptVtt" });
		try {
			const mediaType = this.getCursorMediaType(cursor);
			if (mediaType !== "audio" && mediaType !== "video") {
				throw new Error("Timed transcript (VTT) is currently only supported for audio/video files.");
			}

			if (metadataTranscriptProvider === TRANSCRIPT_PROVIDER_AWS_TRANSCRIBE) {
				const s3Key = this.getCursorS3Key(cursor);
				if (!s3Key) {
					throw new Error("Missing S3 key for selected file.");
				}

				let vttText = "";
				let generationError = null;
				try {
					const awsResponse = await getAwsTranscribeLambda(JSON.stringify({
						bucket: env.s3.assetsBucket,
						key: s3Key,
						fileName: cursor.name || "",
						mediaType,
						response_format: "vtt"
					}), { showAlert: false });

					vttText = this.cleanMetadataTranscriptVtt(this.extractAwsTranscribeVtt(awsResponse));
					if (!vttText) {
						const maybeText = this.extractAwsTranscribeText(awsResponse);
						vttText = this.cleanMetadataTranscriptVtt(maybeText);
					}
				} catch (err) {
					generationError = err;
				}

				if (!vttText) {
					const awsArtifacts = await this.fetchAwsTranscribeCompanionContent(cursor);
					vttText = awsArtifacts.transcriptVtt;
				}

				if (!vttText) {
					if (generationError) {
						throw new Error(`AWS Transcribe VTT generation failed: ${generationError?.message || generationError}`);
					}
					throw new Error("No AWS VTT generated and no sidecar found. Expected '-subtitles.vtt' companion output.");
				}

				if (!/-->/m.test(vttText)) {
					throw new Error("Returned AWS VTT did not include timestamp cues.");
				}

				this.setState({ metadataEditorTranscriptVtt: vttText });
				return;
			}

			const s3Key = this.getCursorS3Key(cursor);
			if (!s3Key) {
				throw new Error("Missing S3 key for selected file.");
			}

			const response = await getAudioTranscriptionsLambda(JSON.stringify({
				bucket: env.s3.assetsBucket,
				key: s3Key,
				fileName: cursor.name || "",
				mediaType,
				model: "whisper-1",
				response_format: "vtt"
			}));

			const rawVtt = this.extractResponsesText(response);
			if (!/-->/m.test(`${rawVtt || ""}`)) {
				throw new Error(
					"VTT output did not include timestamp cues. Verify inline aiAssistant lambda forwards response_format='vtt'."
				);
			}
			const cleanedVtt = this.cleanMetadataTranscriptVtt(rawVtt);
			if (!cleanedVtt) {
				throw new Error("Generation returned empty VTT content.");
			}
			this.setState({ metadataEditorTranscriptVtt: cleanedVtt });
		} catch (err) {
			showError("Generate VTT", err?.message || `${err}`);
		} finally {
			this.setState({ metadataGeneratingField: "" });
		}
	}

	async handleGenerateMetadataTags() {
		const { cursor, metadataTagsProvider } = this.state;
		if (!cursor || cursor.type !== "file") {
			showError("Metadata", "Select a file before generating tags.");
			return;
		}

		this.setState({ metadataGeneratingField: "tags" });
		try {
			if (metadataTagsProvider === TAGS_PROVIDER_REKOGNITION) {
				const s3Key = this.getCursorS3Key(cursor);
				if (!s3Key) {
					throw new Error("Missing S3 key for selected file.");
				}

				let generatedTags = [];
				let generationError = null;
				try {
					const rekognitionResponse = await getRekognitionTagsLambda(JSON.stringify({
						bucket: env.s3.assetsBucket,
						key: s3Key,
						fileName: cursor.name || "",
						maxLabels: 25,
						minConfidence: 70
					}), { showAlert: false });

					generatedTags = this.extractTagsFromRekognitionPayload(rekognitionResponse);
				} catch (err) {
					generationError = err;
				}

				if (!generatedTags.length) {
					generatedTags = this.mergeUniqueTags(this.normalizeTags(cursor?.metaData?.rekognitionTags || []));
				}
				if (!generatedTags.length) {
					if (generationError) {
						throw new Error(`Rekognition tag generation failed: ${generationError?.message || generationError}`);
					}
					throw new Error("No Rekognition tags generated and no existing Rekognition tags available.");
				}

				this.setState((prev) => ({
					tagsEditorPrimary: this.mergeUniqueTags([...(prev.tagsEditorPrimary || []), ...generatedTags])
				}));
				return;
			}

			const prompt = [
				"You are generating searchable tags for a Drive asset.",
				"Return only one comma-separated line of tags (no bullets, no explanations).",
				"Use short phrases. Max 15 tags.",
				"",
				this.buildMetadataGenerationContext()
			].join("\n");
			const responseText = await this.runMetadataResponsesPrompt(prompt);
			const generatedTags = this.parseGeneratedTags(responseText);
			if (!generatedTags.length) {
				throw new Error("Generation returned no tags.");
			}
			this.setState((prev) => ({
				tagsEditorPrimary: this.mergeUniqueTags([...(prev.tagsEditorPrimary || []), ...generatedTags])
			}));
		} catch (err) {
			showError("Generate Tags", err?.message || `${err}`);
		} finally {
			this.setState({ metadataGeneratingField: "" });
		}
	}

	normalizePathForLookup(pathValue) {
		if (!pathValue) {
			return "";
		}
		let path = Array.isArray(pathValue) ? pathValue.join("/") : `${pathValue}`;
		path = path.trim().replace(/^\/+|\/+$/g, "");

		// Compare both with and without orgId in root prefix.
		path = path.replace(/^(public|private)\/[^/]+\//, "$1/");
		return path;
	}

	extractTagsFromAlgoliaHit(hit) {
		if (!hit || typeof hit !== "object") {
			return [];
		}

		return this.mergeUniqueTags([
			...this.normalizeTags(hit.labels),
			...this.normalizeTags(hit.tags),
			...this.normalizeTags(hit?.metaData?.tags),
			...this.normalizeTags(hit?.metaData?.rekognitionTags),
			...this.normalizeTags(hit?.metaData?.openAiTags)
		]);
	}

	extractMetadataFromAlgoliaHit(hit) {
		if (!hit || typeof hit !== "object") {
			return { tags: [], title: "", description: "", transcript: "", transcriptVtt: "" };
		}

		const tags = this.extractTagsFromAlgoliaHit(hit);
		const title = this.cleanMetadataTitle(
			hit?.metaData?.title ||
			hit?.title ||
			""
		);
		const description = this.cleanMetadataDescription(
			hit?.metaData?.description ||
			hit?.description ||
			""
		);
		const transcript = this.cleanMetadataTranscript(
			hit?.metaData?.transcript ||
			hit?.transcript ||
			""
		);
		const transcriptVtt = this.cleanMetadataTranscriptVtt(
			hit?.metaData?.transcriptVtt ||
			hit?.transcriptVtt ||
			""
		);

		return { tags, title, description, transcript, transcriptVtt };
	}

	async fetchAlgoliaTagSuggestions(node) {
		const orgId = getOrgId();
		const indexName = `prod_DRIVE_org_${orgId}`;
		const index = getClient2().initIndex(indexName);
		const attributesToRetrieve = ["objectID", "guid", "path", "labels", "tags", "metaData"];
		const normalizedNodePath = this.normalizePathForLookup(node.path || node.fullPath);

		// Fast-path: try getObject by guid (works when objectID == guid).
		if (node.guid) {
			try {
				const byObjectId = await index.getObject(node.guid, { attributesToRetrieve });
				const meta = this.extractMetadataFromAlgoliaHit(byObjectId);
				if (meta.tags.length > 0 || meta.title || meta.description) {
					return meta;
				}
			} catch (_err) {
				// expected for indexes where objectID is not guid.
			}
		}

		// Fallback: text search then exact-match by guid/path.
		const searchTerm = (node.name || "").trim();
		const result = await index.search(searchTerm || "", {
			hitsPerPage: 75,
			attributesToRetrieve
		});
		const hits = Array.isArray(result?.hits) ? result.hits : [];
		if (!hits.length) {
			return { tags: [], title: "", description: "", transcript: "", transcriptVtt: "" };
		}

		const matchedHit = hits.find((hit) => {
			const sameGuid = !!node.guid && (hit.guid === node.guid || hit.objectID === node.guid);
			const hitPath = this.normalizePathForLookup(hit.path);
			const samePath = !!normalizedNodePath && !!hitPath && hitPath === normalizedNodePath;
			return sameGuid || samePath;
		}) || hits[0];

		return this.extractMetadataFromAlgoliaHit(matchedHit);
	}

	async loadAlgoliaSuggestionsForTags(node) {
		try {
			const algoliaMeta = await this.fetchAlgoliaTagSuggestions(node);
			const algoliaTags = algoliaMeta?.tags || [];
			this.setState((prev) => {
				// User may have closed modal before async result.
				if (!prev.showTagsModal) {
					return null;
				}
				const primarySet = new Set((prev.tagsEditorPrimary || []).map((tag) => `${tag}`.toLowerCase()));
				const mergedSecondary = this.mergeUniqueTags([
					...(prev.tagsEditorSecondary || []),
					...(algoliaTags || [])
				]).filter((tag) => !primarySet.has(`${tag}`.toLowerCase()));

				const updates = {
					tagsEditorSecondary: mergedSecondary,
					tagsEditorLoadingSuggestions: false
				};
				if (!prev.metadataEditorTitle && algoliaMeta?.title) {
					updates.metadataEditorTitle = algoliaMeta.title;
				}
				if (!prev.metadataEditorDescription && algoliaMeta?.description) {
					updates.metadataEditorDescription = algoliaMeta.description;
				}
				if (!prev.metadataEditorTranscript && algoliaMeta?.transcript) {
					updates.metadataEditorTranscript = algoliaMeta.transcript;
				}
				if (!prev.metadataEditorTranscriptVtt && algoliaMeta?.transcriptVtt) {
					updates.metadataEditorTranscriptVtt = algoliaMeta.transcriptVtt;
				}
				return updates;
			});
		} catch (err) {
			console.warn("Unable to load Algolia tag suggestions for selected Drive item:", err?.message || err);
			this.setState({ tagsEditorLoadingSuggestions: false });
		}
	}

	handleShowTagsEditor() {
		const { cursor } = this.state;
		if (!cursor || cursor.type !== "file") {
			showError("Metadata", "Select a file to manage metadata.");
			return;
		}

		const metaData = cursor.metaData && typeof cursor.metaData === "object" ? cursor.metaData : {};
		const primary = this.mergeUniqueTags(this.normalizeTags(metaData.tags));
		const title = this.cleanMetadataTitle(metaData.title || "");
		const description = this.cleanMetadataDescription(metaData.description || "");
		const transcript = this.cleanMetadataTranscript(metaData.transcript || "");
		const transcriptVtt = this.cleanMetadataTranscriptVtt(metaData.transcriptVtt || "");

		const secondaryCandidates = this.mergeUniqueTags([
			...this.normalizeTags(metaData.rekognitionTags),
			...this.normalizeTags(metaData.openAiTags),
			...this.normalizeTags(metaData.labels),
			...this.normalizeTags(cursor.labels)
		]);

		const primaryKeySet = new Set(primary.map((tag) => tag.toLowerCase()));
		const secondary = secondaryCandidates.filter((tag) => !primaryKeySet.has(tag.toLowerCase()));

		this.setState({
			showTagsModal: true,
			tagsEditorInput: "",
			tagsEditorPrimary: primary,
			tagsEditorSecondary: secondary,
			tagsEditorLoadingSuggestions: true,
			metadataEditorTitle: title,
			metadataEditorDescription: description,
			metadataEditorTranscript: transcript,
			metadataEditorTranscriptVtt: transcriptVtt,
			metadataGeneratingField: ""
		});

		this.loadAlgoliaSuggestionsForTags(cursor);
	}

	handleHideTagsEditor() {
		this.setState({
			showTagsModal: false,
			tagsEditorInput: "",
			tagsEditorPrimary: [],
			tagsEditorSecondary: [],
			tagsEditorSaving: false,
			tagsEditorLoadingSuggestions: false,
			metadataEditorTitle: "",
			metadataEditorDescription: "",
			metadataEditorTranscript: "",
			metadataEditorTranscriptVtt: "",
			metadataGeneratingField: ""
		});
	}

	handleTagsInputChange(event) {
		this.setState({ tagsEditorInput: event.target.value });
	}

	handleAddInputTags() {
		const { tagsEditorInput, tagsEditorPrimary } = this.state;
		const inputTags = this.normalizeTags(tagsEditorInput);
		if (!inputTags.length) {
			return;
		}

		this.setState({
			tagsEditorPrimary: this.mergeUniqueTags([...tagsEditorPrimary, ...inputTags]),
			tagsEditorInput: ""
		});
	}

	handleRemovePrimaryTag(tagToRemove) {
		this.setState((prev) => ({
			tagsEditorPrimary: prev.tagsEditorPrimary.filter((tag) => tag.toLowerCase() !== tagToRemove.toLowerCase())
		}));
	}

	handlePromoteSecondaryTag(tagToPromote) {
		this.setState((prev) => ({
			tagsEditorPrimary: this.mergeUniqueTags([...prev.tagsEditorPrimary, tagToPromote]),
			tagsEditorSecondary: prev.tagsEditorSecondary.filter((tag) => tag.toLowerCase() !== tagToPromote.toLowerCase())
		}));
	}

	handlePromoteAllSecondaryTags() {
		this.setState((prev) => ({
			tagsEditorPrimary: this.mergeUniqueTags([...prev.tagsEditorPrimary, ...prev.tagsEditorSecondary]),
			tagsEditorSecondary: []
		}));
	}

	handleMetadataTitleChange(event) {
		const rawValue = `${event?.target?.value || ""}`;
		this.setState({
			metadataEditorTitle: rawValue.slice(0, MAX_METADATA_TITLE_CHARS)
		});
	}

	handleMetadataDescriptionChange(event) {
		const rawValue = `${event?.target?.value || ""}`;
		this.setState({
			metadataEditorDescription: rawValue.slice(0, MAX_METADATA_DESCRIPTION_CHARS)
		});
	}

	handleMetadataTranscriptChange(event) {
		const rawValue = `${event?.target?.value || ""}`;
		this.setState({
			metadataEditorTranscript: rawValue.slice(0, MAX_METADATA_TRANSCRIPT_CHARS)
		});
	}

	handleMetadataTranscriptVttChange(event) {
		const rawValue = `${event?.target?.value || ""}`;
		this.setState({
			metadataEditorTranscriptVtt: rawValue.slice(0, MAX_METADATA_TRANSCRIPT_VTT_CHARS)
		});
	}

	async handleSaveTags() {
		const {
			cursor,
			tagsEditorPrimary,
			metadataEditorTitle,
			metadataEditorDescription,
			metadataEditorTranscript,
			metadataEditorTranscriptVtt
		} = this.state;
		if (!cursor || cursor.type !== "file") {
			showError("Metadata", "Select a file to save metadata.");
			return;
		}

		const path = cursor.path || cursor.fullPath;
		if (!path) {
			showError("Metadata", "Unable to save metadata because file path is missing.");
			return;
		}

		const metaData = cursor.metaData && typeof cursor.metaData === "object" ? _.cloneDeep(cursor.metaData) : {};
		metaData.tags = this.mergeUniqueTags(tagsEditorPrimary);
		const title = this.cleanMetadataTitle(metadataEditorTitle);
		const description = this.cleanMetadataDescription(metadataEditorDescription);
		const transcript = this.cleanMetadataTranscript(metadataEditorTranscript);
		const transcriptVtt = this.cleanMetadataTranscriptVtt(metadataEditorTranscriptVtt);
		if (title) {
			metaData.title = title;
		} else {
			delete metaData.title;
		}
		if (description) {
			metaData.description = description;
		} else {
			delete metaData.description;
		}
		if (transcript) {
			metaData.transcript = transcript;
		} else {
			delete metaData.transcript;
		}
		if (transcriptVtt) {
			metaData.transcriptVtt = transcriptVtt;
		} else {
			delete metaData.transcriptVtt;
		}

		this.setState({ tagsEditorSaving: true });

		try {
			await refreshCredentials();

			await request
				.put(`${env.apiGateway.baseUrl}${env.apiGateway.endpoints.drive.createObject}`)
				.set({ Authorization: getJwtToken(), "Content-Type": "application/json" })
				.send(JSON.stringify({
					orgId: getOrgId(),
					path: getFullObjectPath(path),
					metaData
				}));

			await listDriveForSelectedFolderSilently();
			setActiveTreeCursorForDriveGuid(cursor.guid);

			this.setState({
				cursor: {
					...cursor,
					metaData
				},
					showTagsModal: false,
					tagsEditorSaving: false,
					tagsEditorInput: "",
					tagsEditorSecondary: [],
					metadataEditorTitle: "",
					metadataEditorDescription: "",
					metadataEditorTranscript: "",
					metadataEditorTranscriptVtt: "",
					metadataGeneratingField: ""
				});
		} catch (err) {
			console.error(err);
			showError("Metadata", `Failed to save metadata: ${err?.message || err}`);
			this.setState({ tagsEditorSaving: false });
		}
	}

	renderPreview(node = this.state.cursor) {
		let preview = null;
		let addPreviewLarge = false;
		let url = null;
		let type = null;
		const processingInfo = this.getPendingVideoProcessingForNode(node);

		if (node && node.type === "file") {
			addPreviewLarge = true;
			url = getUrlForExternalResource(node);
			try {
				type = node?.ext ? getMediaType(node.ext) : null;
			} catch {
				type = null;
			}

			switch (type) {
				case "video":
					preview = url ? (
						<ReactPlayer url={url} width="100%" height="100%" playing={false} playsInline muted={false} loop={false} controls />
					) : null;
					break;
				case "audio":
					preview = url ? <ReactAudioPlayer src={url} controls /> : null;
					break;
				case "pdf":
					preview = url ? (
						<object className="pdf" data={url} type="application/pdf" title="">
							<p>
								Your browser isn't supporting embedded pdf files. You can download the file{" "}
								<a href={url} target="_blank" rel="noreferrer">
									here
								</a>
								.
							</p>
						</object>
					) : null;
					break;
				case "threeD":
					preview = url && validateUrl(url) ? <div>3D preview will go here</div> : null;
					break;
				case "image":
					preview = url && validateUrl(url)
						? (
							<img
								alt="Preview"
								src={url}
								style={{
									width: "100%",
									height: "100%",
									objectFit: "contain",
									background: "#ffffff"
								}}
							/>
						)
						: null;
					break;
				default:
					addPreviewLarge = false;
					preview = <FontAwesomeIcon style={{ fontSize: "10vw" }} icon={getFileTypeIcon(node.ext, node)} />;
			}
		}

		let result = preview;
		if (addPreviewLarge) {
			result = (
				<div style={{ position: "relative", width: "100%", height: "100%" }}>
					{preview}
					<div
						key="open-large"
						className="open-large"
						onClick={() => {
							this.props.dispatch(showMediaPreviewModal, url);
						}}
					>
						<FontAwesomeIcon icon="expand-wide" />
					</div>
					{processingInfo && type === "video" && (
						<div
							style={{
								position: "absolute",
								inset: 0,
								background: "rgba(14, 27, 42, 0.68)",
								color: "#fff",
								display: "flex",
								flexDirection: "column",
								justifyContent: "center",
								alignItems: "center",
								textAlign: "center",
								padding: "24px",
								gap: "10px",
								zIndex: 2
							}}
						>
							<FontAwesomeIcon icon="spinner" spin style={{ fontSize: "24px" }} />
							<div style={{ fontWeight: 700, fontSize: "18px" }}>Processing video</div>
							<div style={{ maxWidth: "520px", lineHeight: 1.5 }}>
								The current preview may still be the original upload. When processing finishes, this playback file will be replaced with the converted output and the preview will refresh automatically.
							</div>
							{processingInfo.description && (
								<div style={{ maxWidth: "520px", fontSize: "12px", opacity: 0.92 }}>
									Target processing: {processingInfo.description}
								</div>
							)}
							{processingInfo.masterPath && (
								<div style={{ maxWidth: "520px", fontSize: "12px", opacity: 0.92 }}>
									Original source preserved in Drive as: <b>{processingInfo.masterPath.split("/").pop()}</b>
								</div>
							)}
						</div>
					)}
				</div>
			);
		}

		return result;
	}

	handleEditDocument() {
		const { cursor } = this.state;
		if (!cursor) {
			showError("Invalid Selection", "Please make sure to select a file for editing.");
			return;
		}
		showSpinner();
		setTimeout(() => {
			getContent(cursor.guid)
				.then((editingContent) => {
					const normalizedEditingContent = normalizeEditorContentForSave(editingContent);
					this.setState({
						editing: true,
						editingContent,
						editingInfo: {
							newDoc: false,
							type: cursor.type
						},
						captureNewDocumentInfo: false,
						editorState: {
							content: normalizedEditingContent,
							validity: { valid: true, error: null }
						}
					});
					hideSpinner();
				})
				.catch((err) => {
					showError("Edit Document", "An error occurred while attempting to open the document for editing: " + err);
					hideSpinner();
				});
		});
	}

	handleCancelEditDocument() {
		this.setState({
			editingContent: null,
			editing: false,
			captureNewDocumentInfo: false
		});
	}

	handleStartCreateNewDocument() {
		this.setState({
			editing: true,
			editingInfo: { newDoc: true, name: null, type: null },
			captureNewDocumentInfo: true
		});
	}

	handleSetStartCreateNewDocumentName(e) {
		const _state = _.cloneDeep(this.state);
		_.set(_state, "editingInfo.name", e.target.value);
		this.setState(_state);
	}

	handleSetStartCreateNewDocumentType(type) {
		const _state = _.cloneDeep(this.state);
		_.set(_state, "editingInfo.type", type);
		const initialContent = normalizeEditorContentForSave(_.get(type, "initialContent", ""));
		_.set(_state, "editingContent", initialContent);
		_.set(_state, "editorState", {
			content: initialContent,
			validity: { valid: true, error: null }
		});
		this.setState(_state);
	}

	handleCancelAddNewDocument() {
		this.setState({
			editContent: null,
			editingInfo: null,
			captureNewDocumentInfo: false
		});
	}

	handleEditNewDocument() {
		this.setState({ captureNewDocumentInfo: false });
	}

	handleEditorContentChange(content) {
		const editorState = _.clone(this.state.editorState);
		editorState.content = content;
		this.setState({ editorState });
	}

	handleEditorContentValidityChange(validity) {
		const editorState = _.clone(this.state.editorState);
		editorState.validity = validity;
		this.setState({ editorState });
	}

	handleSave() {
		const { cursor, editorState, editingInfo } = this.state;
		const { hierarchy } = this.props;
		const refContent = this.currentEditor && this.currentEditor.current && _.isFunction(this.currentEditor.current.getContent)
			? this.currentEditor.current.getContent()
			: null;
		const content = !_.isNil(refContent) ? refContent : editorState.content;
		const { name, type, newDoc } = editingInfo;

		if (newDoc) {
			if (hierarchy.type !== "folder") {
				showError("Create File", "Unable to create file, expected a drive folder to be selected.");
				return;
			}
			if (!type || !type.extension) {
				showError("Create File", "The selected document type doesn't contain information about the file extension, unable to create document.");
				return;
			}
			if (!content || _.isEmpty(content)) {
				showError("Create File", "There is not content, make sure to author some content prior to attempting to save.");
				return;
			}

			const { extension, contentType } = type;
			const path = `${hierarchy.path.join("/")}/${name.replace(`.${extension}`, "")}.${extension}`;
			uploadContent(path, content, contentType, { type: type.type }).then(() => {
				this.handleCancelEditDocument();
			});
		} else {
			if (cursor.type !== "file") {
				showError("Save File", "Unable to save file, expected a file to be selected.");
				return;
			}
			const { contentType } = type;
			const { path } = cursor;
			const fallbackContent = normalizeEditorContentForSave(this.state.editingContent);
			const contentToSave = (!_.isNil(content) && !(_.isString(content) && content === "")) ? content : fallbackContent;
			if (_.isNil(contentToSave) || (_.isString(contentToSave) && contentToSave === "")) {
				showError("Save File", "Unable to save an empty document. Please retry after the editor finishes loading.");
				return;
			}
			uploadContent(path, contentToSave, contentType).then(() => {
				this.handleCancelEditDocument();
			});
		}
	}

	handleShowImageEditorModal() {
		const { cursor } = this.state;
		if (!isImageToolsEnabledForUrlParams(this.props.urlParams)) {
			return;
		}

		const imageEditorTarget = getDriveImageEditorSource(cursor);
		if (!imageEditorTarget) {
			showError("Edit Image", "Select an image file before opening the image editor.");
			return;
		}

		this.setState({
			showImageEditorModal: true,
			imageEditorTarget
		});
	}

	handleCloseImageEditorModal() {
		this.setState({
			showImageEditorModal: false,
			imageEditorTarget: null
		});
	}

	handleCreateEditedImage({ blob, imageName, overwriteImage = false, overwriteTargetPath = "", mimeType = "" }) {
		const { cursor } = this.state;
		if (!blob || !cursor || cursor.type !== "file") {
			const error = new Error("Unable to save edited image.");
			showError("Edit Image", error.message);
			return Promise.reject(error);
		}

		const resolvedMimeType = `${mimeType || blob.type || "image/png"}`.trim() || "image/png";
		const fallbackFileName = resolvedMimeType === "image/jpeg" ? "image-edited.jpg" : "image-edited.png";
		const safeFileName = `${imageName || fallbackFileName}`.trim() || fallbackFileName;
		const file = new File([blob], safeFileName, { type: resolvedMimeType });
		const replaceExistingTarget = overwriteImage ? (overwriteTargetPath || cursor.path || "") : "";
		const targetPath = replaceExistingTarget || (cursor.path ? cursor.path.split("/").slice(0, -1).join("/") : "");

		if (!targetPath) {
			const error = new Error("Unable to determine the destination path for the edited image.");
			showError("Edit Image", error.message);
			return Promise.reject(error);
		}

		return uploadFile(targetPath, file, "image", !!replaceExistingTarget, {
			fileName: safeFileName,
			notOptimized: true
		}).then((uploadResponse) => {
			this.setState({
				showImageEditorModal: false,
				imageEditorTarget: null
			});

			if (uploadResponse && uploadResponse.guid) {
				setActiveTreeCursorForDriveGuid(uploadResponse.guid);
			}
			return uploadResponse;
		}).catch((err) => {
			showError("Edit Image", `An error occurred while attempting to save the edited image. Error: ${err}`);
			throw err;
		});
	}

	handleShowVideoEditorModal() {
		const { cursor } = this.state;
		if (!isMediaToolsEnabledForUrlParams(this.props.urlParams)) {
			return;
		}

		const videoEditorTarget = getDriveVideoEditorSource(cursor);
		if (!videoEditorTarget) {
			showError("Edit Video", "Select a Drive video before opening the video editor.");
			return;
		}

		this.setState({
			showVideoEditorModal: true,
			videoEditorTarget
		});
	}

	handleCloseVideoEditorModal() {
		this.setState({
			showVideoEditorModal: false,
			videoEditorTarget: null
		});
	}

	async handleCreateEditedVideo(options = {}) {
		const videoEditorTarget = this.state.videoEditorTarget;
		if (!videoEditorTarget || !videoEditorTarget.resource) {
			showError("Edit Video", "Unable to save edited video.");
			return;
		}

		const overwriteVideo = options.overwriteVideo === true;
		const overwriteTargetPath = overwriteVideo ? (options.overwriteTargetPath || videoEditorTarget.overwriteTargetPath || "") : "";
		const outputFileName = `${options.outputFileName || videoEditorTarget.defaultOutputFileName || buildEditedVideoOutputFileName(videoEditorTarget.videoFileName)}`.trim();
		const videoProcessingOptions = _.omit(options, ["outputFileName", "overwriteVideo", "overwriteTargetPath"]);

		try {
			showInfoToast("Submitting video edit for processing...", {
				autoClose: 5000
			});
			setStoredVideoProcessingOptions(videoProcessingOptions);
			const uploadResponse = await processExistingDriveVideoFile(videoEditorTarget.resource, {
				outputFileName,
				overwriteTargetPath,
				videoProcessingOptions,
				sourceFileName: videoEditorTarget.videoFileName || videoEditorTarget.label || "video.mp4",
				sourceContentType: _.get(videoEditorTarget.resource, "metaData.masterVideoContentType", "") || "video/mp4"
			});

			this.registerPendingVideoProcessingUpload(uploadResponse, {
				name: uploadResponse.fileName || outputFileName,
				type: "video/mp4"
			}, videoProcessingOptions);
			this.setState({
				showVideoEditorModal: false,
				videoEditorTarget: null,
				isSearchMode: false,
				filter: ""
			});
			const editedVideoFolderPath = uploadResponse && uploadResponse.path
				? `${uploadResponse.path.split("/").slice(0, -1).join("/")}/`
				: "";
			try {
				if (editedVideoFolderPath) {
					await selectFolderAndListDrive(editedVideoFolderPath);
				} else {
					await listDriveForSelectedFolderSilently();
				}
			} catch (err) {
				console.warn("Unable to silently refresh selected Drive folder after editing video", err);
			}
			if (uploadResponse && uploadResponse.guid) {
				setActiveTreeCursorForDriveGuid(uploadResponse.guid);
			}
			showSuccessToast(overwriteVideo ? "Queued video processing to overwrite the selected Drive video." : "Queued edited video processing.");
		} catch (err) {
			showError("Edit Video", `An error occurred while attempting to save the edited video. Error: ${err?.message || err}`);
		}
	}

	handleSelectFolderAndListDrive(path) {
		clearSelectionAndActiveTreeCursor();
		selectFolderAndListDrive(path);
		this.setState({ cursor: null, filter: "" });
	}

	handleSelectActivityDriveRootFolder() {
		let path = getDriveRootPath(true);
		if (path) {
			let fullPath = getFullObjectPath("private/activities/" + path + "/");
			if (fullPath !== this.props.selectedFolder) {
				selectFolderAndListDrive(fullPath);
			}
		}
	}

	renderBreadcrumbs() {
		let { selectedFolder } = this.props;
		let breadcrumbItems = [];

		if (selectedFolder) {
			let folderSlugs = selectedFolder.split("/");
			let currentPath = "";
			let breadcrumbData = [];

			folderSlugs.map((folderSlug, i) => {
				let name;
				let folderPath;
				if (i > 0 && folderSlug) {
					if (i === 1) {
						folderPath = folderSlugs[0] + "/" + folderSlugs[1] + "/";
						name = folderSlugs[0];
					} else {
						folderPath = folderSlugs[i] + "/";
						name = folderSlugs[i];
					}
					let active = false;
					if (i === folderSlugs.length - 2) {
						active = true;
					}
					currentPath += folderPath;
					breadcrumbData.push({ name, folderPath: currentPath, active });
				}
			});

			breadcrumbData.map((data) => {
				breadcrumbItems.push(
					<Breadcrumb.Item key={data.folderPath} active={data.active} onClick={data.active ? null : () => this.handleSelectFolderAndListDrive(data.folderPath)}>
						{data.name}
					</Breadcrumb.Item>
				);
			});
		}

		return (
			<div className={styles["breadcrumb-container"]}>
				<Breadcrumb>
					<Breadcrumb.Item active={!selectedFolder ? true : false} onClick={() => this.handleSelectFolderAndListDrive("")}>
						Drive
					</Breadcrumb.Item>
					{breadcrumbItems}
				</Breadcrumb>
			</div>
		);
	}

	render() {
		const { cursor, moving, copying, editing, editingInfo, editingContent, copyInfo, moveInfo } = this.state;
		const { validity } = this.state.editorState;
		const {
			inline,
			edit,
			showSpinner: showSpinnerFlag,
			hideSearchInput,
			hideActionBar,
			okCancel,
			folderOnly,
			actionBarTop,
			hierarchy,
			settings,
			handleQuickUpload,
			acceptType
		} = this.props;

		if (!hierarchy) {
			return (
				<div style={{ width: "100%" }}>
					<div>Loading files...please be patient.</div>
					<AmbifiLoader show={showSpinnerFlag} fullPage={!inline} panel={inline} />
				</div>
			);
		}

		const buttons = [];
		let deleteButton = null;
		let actionBar = null;
		let okCancelBar = null;

		const { editors } = this.props;
			let editor = null;
			if (editors && cursor) {
				const { metaData } = cursor;
				if (metaData) {
					const { type } = metaData;
				if (type && editors[type]) {
					editor = editors[type];
				}
			}
			const extesnionKey = `extension/${cursor?.ext}`;
			if (!editor && cursor?.ext && editors[extesnionKey]) {
				editor = editors[extesnionKey];
			}
		}

		let editType, editName;
		if (editingInfo) {
			const { name, type } = editingInfo;
			editType = type;
			editName = name;
			if (type && type.component) {
				editor = type;
			}
		}
		const editTypeKey = editType && editors
			? (_.findKey(editors, (editorDef) => editorDef === editType) || "")
			: "";
		const createableEditorKeys = editors
			? _.keys(editors).filter((editorKey) => _.get(editors[editorKey], "showInNewDocumentMenu", true) !== false)
			: [];

		const createMenuComponent = (title, icon, key, onClick, extraProps = {}) => {
			if (inline) {
				return (
					<MenuItem key={key} onClick={onClick} {...extraProps}>
						<FontAwesomeIcon icon={icon} /> {title}
					</MenuItem>
				);
			} else {
				return (
					<Button key={key} onClick={onClick} title={title} aria-label={title} {...extraProps}>
						<FontAwesomeIcon icon={icon} /> <span className="drive-action-label">{title}</span>
					</Button>
				);
			}
		};

		const visibleMedia = this.getVisibleMediaFiles();
		const metadataActionControlHeight = 34;
		const metadataActionButtonStyle = {
			height: `${metadataActionControlHeight}px`,
			minHeight: `${metadataActionControlHeight}px`,
			display: "inline-flex",
			alignItems: "center",
			justifyContent: "center",
			whiteSpace: "nowrap",
			padding: "0 12px"
		};
		const metadataActionSelectStyle = {
			height: `${metadataActionControlHeight}px`,
			minHeight: `${metadataActionControlHeight}px`,
			marginBottom: "0px",
			paddingTop: "0px",
			paddingBottom: "0px",
			lineHeight: `${metadataActionControlHeight}px`
		};

			const handleQuickUploadButton = createMenuComponent("Upload File", "upload", "drive-upload-file-button", () => {
				handleQuickUpload(false);
			});
			const canEditImage = isImageToolsEnabledForUrlParams(this.props.urlParams) && !!getDriveImageEditorSource(cursor);
			const canEditVideo = isMediaToolsEnabledForUrlParams(this.props.urlParams) && !!getDriveVideoEditorSource(cursor);
			const showDriveVideoAdvancedToggle = isMediaToolsEnabledForUrlParams(this.props.urlParams) && !!edit && !hideActionBar && !this.props.hideVideoAdvancedToggle;

		if (edit && !hideActionBar) {
			if (moving || copying) {
				let selectedFolderSameOrigin = false;
				if (moving) {
					if (moveInfo.originParentFolderPath === hierarchy.fullPath) { selectedFolderSameOrigin = true; }
				} else {
					if (copyInfo.originParentFolderPath === hierarchy.fullPath) { selectedFolderSameOrigin = true; }
				}

				buttons.push(
					createMenuComponent(
						moving ? "Move Here" : "Paste Here",
						moving ? "check" : "paste",
						"drive-move-file-drop",
						moving ? this.handleMove : this.handleCopy,
						{
							disabled: hierarchy.type !== "folder" || (hierarchy.hasOwnProperty("allowCreate") && !hierarchy.allowCreate) || selectedFolderSameOrigin,
							bsStyle: "success"
						}
					)
				);
				buttons.push(createMenuComponent("Cancel", "ban", "drive-cancel-move-file", moving ? this.handleCancelMove : this.handleCancelCopy));
			} else {
				const folderAllowCreate = hierarchy.type === "folder" && (!hierarchy.hasOwnProperty("allowCreate") || hierarchy.allowCreate);

				if (folderAllowCreate) {
					buttons.push(createMenuComponent("Create Folder", "folder", "drive-create-folder", this.handleShowCreateFolderModal));

					if (!_.isEmpty(editors)) {
						buttons.push(createMenuComponent("New", "plus-circle", "drive-new-file-button", this.handleStartCreateNewDocument));
					}

					buttons.push(createMenuComponent("Paste", "paste", "drive-paste-clipboard-button", this.handleShowPasteClipboardModal));
					buttons.push(createMenuComponent("Upload File", "upload", "drive-upload-file-button", this.handleShowUploadFile));
					buttons.push(createMenuComponent("Upload Folder", "folder-open", "drive-upload-folder-button", this.handleShowUploadFolder));
				}

					if (cursor) {
						if (cursor.type === "file") {
							buttons.push(createMenuComponent("Download", "download", "drive-download-file-button", this.handleDownloadFile, { bsStyle: "primary" }));
							buttons.push(createMenuComponent("Metadata", "tags", "drive-tags-button", this.handleShowTagsEditor));
						}

					if (editor && cursor.type === "file") {
						buttons.push(createMenuComponent("Edit", "file-edit", "drive-edit-file-button", this.handleEditDocument));
					}

					if (canEditImage) {
						buttons.push(createMenuComponent("Edit Image", "image", "drive-edit-image-button", this.handleShowImageEditorModal));
					}

					if (canEditVideo) {
						buttons.push(createMenuComponent("Edit Video", "video", "drive-edit-video-button", this.handleShowVideoEditorModal));
					}

					if (!cursor.hasOwnProperty("allowMoveCopyRename") || cursor.allowMoveCopyRename) {
						const renameButton = createMenuComponent("Rename", "pencil", "drive-rename-button", this.handleStartRename);
						buttons.push(
							createMenuComponent("Copy", ["far", "copy"], "drive-copy-button", this.handleStartCopy),
							createMenuComponent("Move", "arrows", "drive-move-button", this.handleStartMove)
						);
						buttons.push(renameButton);
					}

					if (!cursor.hasOwnProperty("allowDelete") || cursor.allowDelete) {
						deleteButton = createMenuComponent("Delete", "times", "drive-delete-button", this.handleDelete, { bsStyle: "danger" });
					}
				}
			}
		} else if (settings.mode === "list" && handleQuickUpload) {
			buttons.push(handleQuickUploadButton);
		}

		if (deleteButton) {
			buttons.push(deleteButton);
		}

		if (inline && this.props.editActivity) {
			const viewActivityDriveRootButton = createMenuComponent("View Activity Root", "hdd", "drive-view-root-button", this.handleSelectActivityDriveRootFolder);
			buttons.push(viewActivityDriveRootButton);
		}

		actionBar =
			buttons && buttons.length > 0
				? !inline
					? (
						<div key="drive-copy-move-operations-group" className="drive-action-bar">
							{buttons}
						</div>
					)
					: (
						<DropdownButton componentClass={InputGroup.Button} noCaret bsStyle="primary" pullRight title={<FontAwesomeIcon icon="ellipsis-v" />}>
							{buttons}
						</DropdownButton>
					)
				: null;
		const hasBottomActionBar = !inline && !actionBarTop && !!actionBar;

		if (okCancel) {
			okCancelBar = (
				<div className="button-bar">
					<Button bsStyle="danger" onClick={this.handleCancel}>
						<FontAwesomeIcon icon="ban" /> Cancel
					</Button>
					{cursor && (cursor.type === "file" || (folderOnly && cursor.type === "folder")) && (
						<Button bsStyle="success" disabled={!cursor} onClick={this.handleOk}>
							<FontAwesomeIcon icon="check" /> OK
						</Button>
					)}
				</div>
			);
		}

		// ----- Gallery-safe computations -----
		const { galleryImages, galleryIndex } = this.state;
		const inRange = Array.isArray(galleryImages) && galleryIndex >= 0 && galleryIndex < galleryImages.length;
		const currentImage = inRange ? galleryImages[galleryIndex] : null;

		const mediaType = currentImage ? (() => { try { return getMediaType(currentImage.ext); } catch { return null; } })() : null;
		const url = currentImage ? getUrlForExternalResource(currentImage) : null;

			let mediaPreview = null;
		if (!currentImage || !url) {
			mediaPreview = <div>No media selected</div>;
		} else {
			switch (mediaType) {
				case "image":
					mediaPreview = (
						<img
							key={currentImage.guid || currentImage.path || currentImage.name}
							src={url}
							alt={currentImage.name}
							onClick={() => window.open(url, "_blank")}
							className="gallery-image"
						/>
					);
					break;
				case "video":
					mediaPreview = (
						<ReactPlayer
							key={currentImage.guid || currentImage.path || currentImage.name}
							url={url}
							controls
							playing={false}
							muted={false}
							playsInline
							loop={false}
							width="100%"
							height="95%"
							className="gallery-video"
						/>
					);
					break;
				case "audio":
					mediaPreview = (
						<ReactAudioPlayer key={currentImage.guid || currentImage.path || currentImage.name} src={url} controls className="gallery-audio" />
					);
					break;
				case "pdf":
					mediaPreview = (
						<object data={url} type="application/pdf" width="100%" height="90vh" style={{ border: "none" }}>
							<p>
								Your browser doesn't support embedded PDFs.{" "}
								<a href={url} target="_blank" rel="noopener noreferrer">
									Click here to download the file.
								</a>
							</p>
						</object>
					);
					break;
				default:
					mediaPreview = <div>Unsupported media type</div>;
			}
			}

			let videoEditorModal;
			if (this.state.showVideoEditorModal && this.state.videoEditorTarget) {
				const videoEditorTarget = this.state.videoEditorTarget;
				const serverPreviewSource = videoEditorTarget.overwriteTargetPath ? {
					bucket: _.get(env, "s3.assetsBucket", ""),
					key: videoEditorTarget.overwriteTargetPath,
					frameSeconds: 0,
					revision: Number(_.get(videoEditorTarget, "resource.revision")) || 0
				} : null;
				videoEditorModal = (
					<VideoProcessingOptionsModal
						open={this.state.showVideoEditorModal}
						onClose={this.handleCloseVideoEditorModal}
						onContinue={this.handleCreateEditedVideo}
						initialOptions={getStoredVideoProcessingOptions()}
						fileName={videoEditorTarget.videoFileName || videoEditorTarget.label || "video.mp4"}
						previewUrl={videoEditorTarget.url}
						serverPreviewSource={serverPreviewSource}
						videoCount={1}
						allowFileRename
						defaultOutputFileName={videoEditorTarget.defaultOutputFileName}
						allowOverwriteOption={!!videoEditorTarget.overwriteTargetPath}
						overwriteTargetPath={videoEditorTarget.overwriteTargetPath || ""}
						orientationSummary={getDefaultVideoOrientationSummary(1)}
						showEditVideoButton={false}
						deferInitialServerPreview
						closeOnContinue
						title="Edit Video"
						description={<span>Adjust processing options for <b>{videoEditorTarget.videoFileName || videoEditorTarget.label || "video.mp4"}</b>, then save a new Drive video or overwrite the current one.</span>}
						continueLabel="Save Video"
					/>
				);
			}

			let videoProcessingOptionsModal;
			if (this.state.showVideoProcessingOptionsModal) {
					videoProcessingOptionsModal = (
						<VideoProcessingOptionsModal
							open={this.state.showVideoProcessingOptionsModal}
							onClose={this.handleCloseVideoProcessingOptionsModal}
							onContinue={this.handleContinueVideoProcessingOptionsModal}
							initialOptions={getStoredVideoProcessingOptions()}
							fileName={_.get(this.state.pendingUploadFiles, "[0].name", "")}
							previewFile={_.get(this.state.pendingUploadFiles, "[0]", null)}
							videoCount={(Array.isArray(this.state.pendingUploadFiles) ? this.state.pendingUploadFiles.filter((file) => isVideoFileCandidate(file)).length : 0) || 1}
							allowFileRename={(Array.isArray(this.state.pendingUploadFiles) ? this.state.pendingUploadFiles.length : 0) === 1}
							orientationSummary={this.state.pendingUploadOrientationSummary}
						/>
					);
				}

			return (
				<div className={`ambifi-drive ${inline ? "inline" : "full"} ${hasBottomActionBar ? "has-bottom-action-bar" : ""}`}>
					<input multiple key={"drive-file-upload"} id="drive-upload" type="file" onChange={this.handleSelectUploadFile} style={{ display: "none" }} />
					<input multiple key={"drive-folder-upload"} id="drive-folder-upload" type="file" webkitdirectory="true" directory="true" onChange={this.handleSelectUploadFolder} style={{ display: "none" }} />
					{(!inline && actionBarTop) && actionBar}
					{showDriveVideoAdvancedToggle &&
						<div style={{ marginBottom: "12px" }}>
							<VideoProcessingAdvancedToggle enabled={this.state.showAdvancedVideoOptions} onChange={this.handleToggleVideoAdvancedOptions} />
						</div>
					}
					{videoEditorModal}

					<div className="drive-header">
					{!hideSearchInput && (
						<div className="drive-controls">
							<div className="drive-search-control search-input">
								{(getOrgId() === "a25f9e42-23cd-11ec-9068-066917b38554" || getOrgId() === "75a99644-d769-11ec-8330-069463faa5ff" || getOrgId() === "332a9d47-6e36-11e8-a392-061714f61e3e" || getOrgId() === "3c2c0579-2bdc-11e9-a392-061714f61e3e") ? (
									<SearchInput
										onModeChange={(isSearching) =>
											this.setState({
												isSearchMode: isSearching,
												galleryIndex: 0,
												searchImageFiles: []
											})
										}
									/>
								) : (
									<>
										<span className="drive-search-icon">
											<FontAwesomeIcon icon="search" />
										</span>
										<input
											className="form-control"
											onChange={this.onFilterChange.bind(this)}
											placeholder="Search Drive"
											type="text"
											value={this.state.filter}
										/>
									</>
								)}
							</div>

							<div className="drive-control-actions">
								<Button
									className="drive-label-toggle-button"
									onClick={this.toggleShowAllLabels}
								>
									{this.state.showAllLabels ? "Hide Labels" : "Show Labels"}
								</Button>

								{visibleMedia.length > 0 && (
									<Button
										onClick={() => {
											const visibleFiles = this.getVisibleMediaFiles();
											const { selectedNode } = this.state;
											let startIndex = 0;
											if (selectedNode) {
												const matchIndex = visibleFiles.findIndex((node) => node.guid === selectedNode.guid);
												if (matchIndex >= 0) { startIndex = matchIndex; }
											}
											this.openGallery(startIndex);
										}}
										disabled={this.state.refreshDisabled}
										title="Open media gallery"
									>
										<FontAwesomeIcon icon={"images"} />
									</Button>
								)}

								<Button
									onClick={() => this.handleSwitchMode(settings.mode === "tree" ? "list" : "tree")}
									disabled={this.state.refreshDisabled}
									title={settings.mode === "tree" ? "Show tile view" : "Show tree view"}
								>
									<FontAwesomeIcon icon={settings.mode === "tree" ? "th-large" : "folder-tree"} />
								</Button>

								<ButtonGroup className="drive-refresh-group">
									<Button
										onClick={this.handleRefresh}
										disabled={this.state.refreshDisabled}
										title="Refresh current folder"
									>
										<FontAwesomeIcon icon="sync" />
									</Button>
									<Button
										onClick={this.handleRefreshAll}
										disabled={this.state.refreshDisabled}
										title="Refresh entire drive"
									>
										Full
									</Button>
								</ButtonGroup>

								{inline && actionBar}
							</div>
						</div>
					)}
				</div>

				{this.state.isSearchMode ? (
					<SearchResultsView
						showAllLabels={this.state.showAllLabels}
						onSelect={this.onSelect}
						onDblClick={this.onDblClick}
						acceptType={acceptType}
						driveComponentId={this.driveComponentId}
						scrollParentRef={this.scrollParentRef}
						mode={settings.mode}
						onSearchImageResultsUpdate={(imageFiles) => this.setState({ searchImageFiles: imageFiles ?? [], galleryIndex: 0 })}
					/>
				) : (
					<>
						<div className="drive-breadcrumbs">{this.renderBreadcrumbs()}</div>
						<div className="drive-tree-wrapper">
							<div className="drive-tree" style={{ height: "100%" }} ref={(ref) => (this.scrollParentRef = ref)}>
								<DriveContext.Provider value={{ driveComponentId: this.driveComponentId }}>
									<ListView
										showAllLabels={this.state.showAllLabels}
										data={hierarchy}
										onSelect={this.onSelect}
										onDblClick={this.onDblClick}
										mode={settings.mode}
										accept={acceptType}
										scrollParentRef={this.scrollParentRef}
										driveComponentId={this.driveComponentId}
									/>
								</DriveContext.Provider>
							</div>
							{settings.mode === "tree" && cursor && cursor.type === "file" && <div className="sticky-preview">{this.renderPreview(cursor)}</div>}
						</div>
					</>
				)}

				<Modal
					open={this.state.showGallery}
					onClose={() => this.setState({ showGallery: false })}
					center
					classNames={{ modal: "photo-gallery-modal" }}
				>
					{this.state.galleryImages.length > 0 && (
						<div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "90vh" }}>
							<div style={{ width: "95vw", textAlign: "center", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
								<Button onClick={this.handlePrevImage}>←</Button>
								{mediaPreview}
								<Button onClick={this.handleNextImage}>→</Button>
							</div>
							<p
								onClick={() => {
									if (url) {
										copyToClipboard(encodeURI(url));
									}
								}}
								title={currentImage?.path || ""}
								style={{ marginTop: "10px", cursor: url ? "pointer" : "default" }}
							>
								{currentImage?.name || ""}
							</p>
						</div>
					)}
				</Modal>

				<Modal open={this.state.showCreateFolderModal} onClose={this.handleCancelAddFolder} classNames={{ modal: "custom-modal" }} closeButton>
					<div>
						<h4>Create Folder</h4>
						<hr />
						<div className="map-modal-body-container">
							<FormGroup controlId="folder-name" validationState={this.state.createFolder && this.state.createFolder.validationState ? this.state.createFolder.validationState : null}>
								<Col componentClass={ControlLabel} sm={12} style={{ textAlign: "left" }}>
									Folder Name
								</Col>
								<Col sm={12}>
									<FormControl onChange={this.handleChangeCreateFolderName} type="text" />
									{this.state.createFolder && this.state.createFolder.validationState !== "success" && (
										<Panel bsStyle="danger">
											<Panel.Heading>{this.state.createFolder.validationError}</Panel.Heading>
										</Panel>
									)}
								</Col>
							</FormGroup>
						</div>
						<div className="modal-footer-container">
							<Button onClick={this.handleCancelAddFolder} style={{ marginRight: "10px" }}>
								Cancel
							</Button>
							<Button disabled={!this.state.createFolder || _.isEmpty(this.state.createFolder.name)} bsStyle="primary" onClick={this.handleAddFolder}>
								OK
							</Button>
						</div>
					</div>
					</Modal>
					<Modal open={this.state.showPasteClipboardModal} onClose={this.handleHidePasteClipboardModal} classNames={{ modal: "custom-modal" }} closeButton>
						<div>
							<h4>Paste Clipboard</h4>
							<hr />
							<div className="map-modal-body-container">
								{this.state.pasteClipboardWaitingForPaste ? (
									<FormGroup controlId="drive-paste-clipboard-target">
										<Col componentClass={ControlLabel} sm={12} style={{ textAlign: "left" }}>
											Clipboard
										</Col>
										<Col sm={12}>
											<div
												ref={this.pasteClipboardTarget}
												contentEditable
												suppressContentEditableWarning
												tabIndex={0}
												style={{
													border: "1px solid #ccc",
													borderRadius: "4px",
													minHeight: "120px",
													padding: "12px",
													outline: "none"
												}}
											>
												Tap here and paste, or press Cmd/Ctrl+V.
											</div>
											<HelpBlock>
												{this.state.pasteClipboardPasteError || "Paste an image, JSON, or text item from the clipboard."}
											</HelpBlock>
										</Col>
									</FormGroup>
								) : (
									<div>
										<FormGroup
											controlId="drive-paste-clipboard-file-name"
											validationState={this.validatePastedClipboardFileName(this.state.pasteClipboardFileName) ? "error" : null}
										>
											<Col componentClass={ControlLabel} sm={12} style={{ textAlign: "left" }}>
												File Name
											</Col>
											<Col sm={12}>
												<FormControl
													autoFocus
													disabled={this.state.pasteClipboardSaving}
													onChange={this.handleChangePasteClipboardFileName}
													type="text"
													value={this.state.pasteClipboardFileName}
												/>
												<HelpBlock>
													{this.validatePastedClipboardFileName(this.state.pasteClipboardFileName) || `Clipboard content will be saved as ${this.state.pasteClipboardContentType === "application/json" ? "JSON" : this.isPasteClipboardImageContentType(this.state.pasteClipboardContentType) ? "image" : "text"}.`}
												</HelpBlock>
											</Col>
										</FormGroup>
										<FormGroup controlId="drive-paste-clipboard-preview">
											<Col componentClass={ControlLabel} sm={12} style={{ textAlign: "left" }}>
												Preview
											</Col>
											<Col sm={12}>
												{this.state.pasteClipboardFile ? (
													<div style={{ border: "1px solid #ddd", borderRadius: "4px", padding: "10px", textAlign: "center" }}>
														{this.state.pasteClipboardPreviewUrl ? (
															<img
																alt="Clipboard preview"
																src={this.state.pasteClipboardPreviewUrl}
																style={{ maxHeight: "320px", maxWidth: "100%", objectFit: "contain" }}
															/>
														) : (
															<div>{this.state.pasteClipboardContentType}</div>
														)}
													</div>
												) : (
													<FormControl
														componentClass="textarea"
														readOnly
														rows={8}
														value={this.state.pasteClipboardText}
													/>
												)}
											</Col>
										</FormGroup>
									</div>
								)}
							</div>
							<div className="modal-footer-container">
								<Button disabled={this.state.pasteClipboardSaving} onClick={this.handleHidePasteClipboardModal} style={{ marginRight: "10px" }}>
									Cancel
								</Button>
								<Button
									disabled={this.state.pasteClipboardSaving || !this.hasPastedClipboardPayload() || !!this.validatePastedClipboardFileName(this.state.pasteClipboardFileName)}
									bsStyle="primary"
									onClick={this.handleCreatePastedClipboardFile}
								>
									{this.state.pasteClipboardSaving ? "Creating..." : "Create File"}
								</Button>
							</div>
						</div>
					</Modal>
					<Modal open={this.state.showUploadFolderOptionsModal} onClose={this.handleCloseUploadFolderOptionsModal} classNames={{ modal: "custom-modal" }} closeButton>
						<div>
							<h4>Upload Folder</h4>
							<hr />
							<div className="map-modal-body-container">
								<div style={{ marginBottom: "12px" }}>
									Select a local folder to upload into the currently selected Drive folder.
								</div>
								<Checkbox checked={this.state.uploadFolderRecursive} onChange={this.handleToggleUploadFolderRecursive}>
									Include subfolders recursively
								</Checkbox>
								<div style={{ color: "#666", marginTop: "8px" }}>
									When unchecked, only files directly inside the selected folder will be uploaded.
								</div>
							</div>
							<div className="modal-footer-container">
								<Button onClick={this.handleCloseUploadFolderOptionsModal} style={{ marginRight: "10px" }}>
									Cancel
								</Button>
								<Button bsStyle="primary" onClick={this.handleBrowseUploadFolder}>
									<FontAwesomeIcon icon="folder-open" /> Select Folder
								</Button>
							</div>
						</div>
					</Modal>
					{videoProcessingOptionsModal}

					<Modal open={this.state.showDeleteOptionsModal} onClose={this.handleCloseDeleteOptionsModal} classNames={{ modal: "custom-modal" }} closeButton>
						<div>
							<h4>Delete File</h4>
							<hr />
							<div className="map-modal-body-container">
								<div style={{ marginBottom: "12px" }}>
									Are you sure you want to delete <b>{_.get(this.state.deleteDialogTarget, "name", "this file")}</b>?
								</div>
								{this.state.deleteDialogRelatedItems.length > 0 && (
									<div style={{ border: "1px solid #e5e7eb", borderRadius: "8px", padding: "12px", background: "#fafafa" }}>
										<label style={{ display: "flex", alignItems: "flex-start", gap: "8px", cursor: "pointer", marginBottom: "10px" }}>
											<input
												type="checkbox"
												checked={this.state.deleteDialogDeleteRelated === true}
												onChange={this.handleToggleDeleteRelated}
												style={{ marginTop: "2px" }}
											/>
											<span>
												<b>Also delete generated child files</b>
												<div style={{ color: "#6b7280", fontSize: "12px", marginTop: "4px" }}>
													This file has {this.state.deleteDialogRelatedItems.length} related generated file{this.state.deleteDialogRelatedItems.length === 1 ? "" : "s"} that can be removed with it.
												</div>
											</span>
										</label>
										<div style={{ maxHeight: "220px", overflowY: "auto", paddingLeft: "24px" }}>
											{this.state.deleteDialogRelatedItems.map((item) => (
												<div key={item.guid} style={{ marginBottom: "8px" }}>
													<div><b>{item.name}</b></div>
													<div style={{ color: "#6b7280", fontSize: "12px" }}>{this.getDeleteRelatedItemLabel(item)}</div>
												</div>
											))}
										</div>
									</div>
								)}
							</div>
							<div className="modal-footer-container">
								<Button onClick={this.handleCloseDeleteOptionsModal} style={{ marginRight: "10px" }}>
									Cancel
								</Button>
								<Button bsStyle="danger" onClick={this.handleConfirmDeleteOptions}>
									{this.state.deleteDialogDeleteRelated && this.state.deleteDialogRelatedItems.length > 0 ? "Delete File + Children" : "Delete File"}
								</Button>
							</div>
						</div>
					</Modal>

					<Modal open={!!this.state.renaming} onClose={this.handleCancelRename} classNames={{ modal: "custom-modal" }} closeButton>
						<div>
							<h4>Rename</h4>
						<hr />
						<div className="map-modal-body-container">
							<FormGroup controlId="folder-name" validationState={this.state.createFolder && this.state.createFolder.validationState ? this.state.createFolder.validationState : null}>
								<Col componentClass={ControlLabel} sm={12} style={{ textAlign: "left" }}>
									<i>{this.state.rename.name}</i> to:
								</Col>
								<Col sm={12}>
									<div style={{ display: "flex", alignItems: "center" }}>
										<FormControl
											autoFocus
											onFocus={(e) => {
												const value = e.target.value;
												if (!value) { return; }
												const indexPeriod = value.lastIndexOf(".");
												if (indexPeriod > -1) {
													e.target.setSelectionRange(0, indexPeriod);
												} else {
													e.target.select();
												}
											}}
											style={{ flex: 1, marginRight: "10px" }}
											value={this.state.rename.fileName}
											onChange={this.handleChangeNameRename}
											type="text"
										/>
										<div></div>
									</div>
								</Col>
							</FormGroup>
						</div>
						<div className="modal-footer-container">
							<Button onClick={this.handleCancelRename} style={{ marginRight: "10px" }}>
								Cancel
							</Button>
							<Button disabled={!this.state.rename || _.isEmpty(this.state.rename.fileName)} bsStyle="primary" onClick={this.handleRename}>
								Rename
							</Button>
							</div>
						</div>
					</Modal>

					<Modal open={!!this.state.showTagsModal} onClose={this.handleHideTagsEditor} classNames={{ modal: "custom-modal" }} closeButton>
						<div>
							<h4>Metadata Editor</h4>
							<hr />
							<div className="map-modal-body-container">
								<div style={{ marginBottom: "10px", color: "#5f6f82" }}>
									Manage title, description, transcript text, and searchable tags for <b>{this.state.cursor?.name || "selected file"}</b>.
								</div>

								<FormGroup controlId="drive-metadata-title-input">
									<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "6px" }}>
										<ControlLabel style={{ marginBottom: 0 }}>Title</ControlLabel>
										<Button
											style={metadataActionButtonStyle}
											onClick={this.handleGenerateMetadataTitle}
											disabled={this.isMetadataGenerationInProgress()}
										>
											{this.isMetadataGenerationInProgress("title") ? "Generating..." : "Generate Title"}
										</Button>
									</div>
									<FormControl
										type="text"
										placeholder="Short display/search title"
										value={this.state.metadataEditorTitle}
										onChange={this.handleMetadataTitleChange}
									/>
									<div style={{ marginTop: "4px", color: "#8b97a6", fontSize: "12px" }}>
										{(this.state.metadataEditorTitle || "").length}/{MAX_METADATA_TITLE_CHARS}
									</div>
								</FormGroup>

								<FormGroup controlId="drive-metadata-description-input">
									<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "6px" }}>
										<ControlLabel style={{ marginBottom: 0 }}>Description</ControlLabel>
										<Button
											style={metadataActionButtonStyle}
											onClick={this.handleGenerateMetadataDescription}
											disabled={this.isMetadataGenerationInProgress()}
										>
											{this.isMetadataGenerationInProgress("description") ? "Generating..." : "Generate Description"}
										</Button>
									</div>
									<FormControl
										componentClass="textarea"
										rows={3}
										placeholder="Concise description for search/discovery"
										value={this.state.metadataEditorDescription}
										onChange={this.handleMetadataDescriptionChange}
									/>
									<div style={{ marginTop: "4px", color: "#8b97a6", fontSize: "12px" }}>
										{(this.state.metadataEditorDescription || "").length}/{MAX_METADATA_DESCRIPTION_CHARS}
									</div>
								</FormGroup>

								<FormGroup controlId="drive-metadata-transcript-input">
									<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "6px", gap: "8px", flexWrap: "wrap" }}>
										<ControlLabel style={{ marginBottom: 0 }}>Transcript / Content Text</ControlLabel>
										<div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
											<FormControl
												componentClass="select"
												value={this.state.metadataTranscriptProvider}
												onChange={this.handleMetadataTranscriptProviderChange}
												disabled={this.isMetadataGenerationInProgress()}
												style={{ width: "180px", ...metadataActionSelectStyle }}
											>
												<option value={TRANSCRIPT_PROVIDER_AWS_TRANSCRIBE}>Amazon Transcribe</option>
												<option value={TRANSCRIPT_PROVIDER_OPENAI}>OpenAI</option>
											</FormControl>
											<Button
												style={metadataActionButtonStyle}
												onClick={this.handleGenerateMetadataTranscript}
												disabled={this.isMetadataGenerationInProgress()}
											>
												{this.isMetadataGenerationInProgress("transcript") ? "Generating..." : "Generate Transcript"}
											</Button>
											<Button
												style={metadataActionButtonStyle}
												onClick={this.handleGenerateMetadataTranscriptVtt}
												disabled={this.isMetadataGenerationInProgress()}
											>
												{this.isMetadataGenerationInProgress("transcriptVtt") ? "Generating..." : "Generate VTT"}
											</Button>
										</div>
									</div>
									<FormControl
										componentClass="textarea"
										rows={5}
										placeholder="Long-form text representation (transcript, narration, image content notes, etc.)"
										value={this.state.metadataEditorTranscript}
										onChange={this.handleMetadataTranscriptChange}
									/>
									<div style={{ marginTop: "4px", color: "#8b97a6", fontSize: "12px" }}>
										{(this.state.metadataEditorTranscript || "").length}/{MAX_METADATA_TRANSCRIPT_CHARS}
									</div>
								</FormGroup>

								<FormGroup controlId="drive-metadata-transcript-vtt-input">
									<ControlLabel>Timed Transcript (VTT)</ControlLabel>
									<FormControl
										componentClass="textarea"
										rows={6}
										placeholder="WEBVTT content for timed captions/subtitles."
										value={this.state.metadataEditorTranscriptVtt}
										onChange={this.handleMetadataTranscriptVttChange}
									/>
									<div style={{ marginTop: "4px", color: "#8b97a6", fontSize: "12px" }}>
										{(this.state.metadataEditorTranscriptVtt || "").length}/{MAX_METADATA_TRANSCRIPT_VTT_CHARS}
									</div>
								</FormGroup>

								<FormGroup controlId="drive-tags-provider">
									<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
										<ControlLabel style={{ marginBottom: 0 }}>Tags</ControlLabel>
										<div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
											<FormControl
												componentClass="select"
												value={this.state.metadataTagsProvider}
												onChange={this.handleMetadataTagsProviderChange}
												disabled={this.isMetadataGenerationInProgress()}
												style={{ width: "190px", ...metadataActionSelectStyle }}
											>
												<option value={TAGS_PROVIDER_OPENAI}>OpenAI</option>
												<option value={TAGS_PROVIDER_REKOGNITION}>AWS Rekognition</option>
											</FormControl>
											<Button
												style={metadataActionButtonStyle}
												onClick={this.handleGenerateMetadataTags}
												disabled={this.isMetadataGenerationInProgress()}
											>
												{this.isMetadataGenerationInProgress("tags") ? "Generating..." : "Generate Tags"}
											</Button>
										</div>
									</div>
								</FormGroup>

								<FormGroup controlId="drive-tags-primary-input">
									<ControlLabel>Add Primary Tags</ControlLabel>
									<div style={{ display: "flex", gap: "8px" }}>
										<FormControl
											type="text"
											placeholder="Add one or more tags (comma separated)"
											value={this.state.tagsEditorInput}
											onChange={this.handleTagsInputChange}
											onKeyDown={(event) => {
												if (event.key === "Enter") {
													event.preventDefault();
													this.handleAddInputTags();
												}
											}}
										/>
										<Button
											bsStyle="primary"
											style={metadataActionButtonStyle}
											onClick={this.handleAddInputTags}
											disabled={this.isMetadataGenerationInProgress()}
										>
											Add
										</Button>
									</div>
								</FormGroup>

								<div style={{ marginTop: "14px" }}>
									<ControlLabel>Primary Tags</ControlLabel>
									{this.state.tagsEditorPrimary.length === 0 ? (
										<div style={{ color: "#8b97a6" }}><i>No primary tags yet.</i></div>
									) : (
										<div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
											{this.state.tagsEditorPrimary.map((tag) => (
												<span
													key={`primary-${tag}`}
													style={{
														display: "inline-flex",
														alignItems: "center",
														gap: "6px",
														padding: "4px 8px",
														borderRadius: "999px",
														backgroundColor: "#e9f3ff",
														color: "#1f4d88",
														fontSize: "12px"
													}}
												>
													{tag}
													<Button
														bsSize="xsmall"
														onClick={() => this.handleRemovePrimaryTag(tag)}
														style={{ lineHeight: "1", padding: "1px 5px" }}
													>
														×
													</Button>
												</span>
											))}
										</div>
									)}
								</div>

								<div style={{ marginTop: "16px" }}>
									<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "6px" }}>
										<ControlLabel style={{ marginBottom: 0 }}>Secondary Suggested Tags</ControlLabel>
										<Button
											style={metadataActionButtonStyle}
											onClick={this.handlePromoteAllSecondaryTags}
											disabled={this.state.tagsEditorSecondary.length === 0}
										>
											Promote All
										</Button>
									</div>
									{this.state.tagsEditorLoadingSuggestions && (
										<div style={{ color: "#8b97a6", marginBottom: "8px" }}>
											<i>Loading suggestions from Algolia...</i>
										</div>
									)}
									{this.state.tagsEditorSecondary.length === 0 ? (
										<div style={{ color: "#8b97a6" }}><i>No secondary tags found.</i></div>
									) : (
										<div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
											{this.state.tagsEditorSecondary.map((tag) => (
												<Button
													key={`secondary-${tag}`}
													bsSize="small"
													onClick={() => this.handlePromoteSecondaryTag(tag)}
													style={{
														borderRadius: "999px",
														padding: "4px 10px",
														backgroundColor: "#f5f7fa",
														border: "1px solid #d8dee8",
														color: "#34495e"
													}}
												>
													+ {tag}
												</Button>
											))}
										</div>
									)}
								</div>
							</div>
							<div className="modal-footer-container">
								<Button onClick={this.handleHideTagsEditor} style={{ ...metadataActionButtonStyle, marginRight: "10px" }}>
									Cancel
								</Button>
								<Button
									bsStyle="primary"
									style={metadataActionButtonStyle}
									onClick={this.handleSaveTags}
									disabled={this.state.tagsEditorSaving || this.isMetadataGenerationInProgress()}
								>
									{this.state.tagsEditorSaving ? "Saving..." : "Save Metadata"}
								</Button>
							</div>
						</div>
					</Modal>

				{editing && (
						<Modal open={editing} onClose={this.handleCancelEditDocument} classNames={{ modal: _.compact(["custom-modal", "templates", this.state.captureNewDocumentInfo ? "new-document-modal" : "", _.get(editor, "modalClassName", "")]).join(" ") }} closeButton>
						{this.state.captureNewDocumentInfo ? (
							<div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
								<div style={{ flex: 0 }}>
									<h3>New Document</h3>
									<hr />
								</div>

								<div className="map-modal-body-container" style={{ flex: 1, overflowY: "auto" }}>
									<FieldGroup id="formControlsDocumentName" type="text" label="Document Name" placeholder={editName} onChange={this.handleSetStartCreateNewDocumentName} />
									<FormGroup>
										<ControlLabel>Select Document Type</ControlLabel>
										<FormControl
											componentClass="select"
											value={editTypeKey}
											onChange={(event) => {
												const nextEditorKey = _.get(event, "target.value", "");
												const nextEditor = nextEditorKey && editors ? editors[nextEditorKey] : null;
												this.handleSetStartCreateNewDocumentType(nextEditor);
											}}
										>
											<option value="">Select a document type...</option>
											{editors && _.map(createableEditorKeys, (editorKey) => {
												const editorDef = editors[editorKey];
												return (
													<option key={editorKey} value={editorKey}>
														{editorDef.title}
													</option>
												);
											})}
										</FormControl>
									</FormGroup>
								</div>

								<div className="modal-footer-container space-between" style={{ flex: 0 }}>
									<Button onClick={this.handleCancelEditDocument} style={{ marginRight: "10px" }}>
										<FontAwesomeIcon icon="ban" /> Cancel
									</Button>
									<Button bsStyle="primary" onClick={this.handleEditNewDocument}>
										<FontAwesomeIcon icon="check" /> Ok
									</Button>
								</div>
							</div>
						) : (
							<div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
								<div style={{ flex: 0 }}>
									<h3>Edit</h3>
									<hr />
								</div>
								<div className="map-modal-body-container" style={{ flex: 1, overflowY: "auto" }}>
									{editor?.component && <editor.component ref={this.currentEditor} onChange={this.handleEditorContentChange} onValidityChange={this.handleEditorContentValidityChange} content={editingContent} />}
								</div>
								<div className="modal-footer-container space-between" style={{ flex: 0 }}>
									<Button onClick={this.handleCancelEditDocument}>
										<FontAwesomeIcon icon="ban" /> Cancel
									</Button>
									<Button bsStyle="primary" onClick={this.handleSave} disabled={validity && !validity.valid}>
										<FontAwesomeIcon icon="save" /> Save
									</Button>
								</div>
							</div>
						)}
					</Modal>
				)}

				{this.state.showImageEditorModal && this.state.imageEditorTarget && (
					<ImageEditorModal
						open={this.state.showImageEditorModal}
						onClose={this.handleCloseImageEditorModal}
						onCreate={this.handleCreateEditedImage}
						imageUrl={this.state.imageEditorTarget.url}
						driveObjectGuid={this.state.imageEditorTarget.driveObjectGuid}
						imageLabel={this.state.imageEditorTarget.label}
						defaultBaseName={this.state.imageEditorTarget.defaultBaseName}
						originalImageName={this.state.imageEditorTarget.originalImageName}
						overwriteTargetPath={this.state.imageEditorTarget.overwriteTargetPath}
						urlParams={this.props.urlParams}
					/>
				)}

				<div className={`drive-footer ${hasBottomActionBar ? "drive-footer-has-action-bar" : ""}`}>
					{!inline && !actionBarTop && actionBar}
					{okCancelBar}
				</div>

				<AmbifiLoader show={showSpinnerFlag} fullPage={!inline} panel={inline} />
			</div>
		);
	}

	async UNSAFE_componentWillMount() {
		showSpinner();
	}

	async componentDidMount() {
		const { lastActiveGuid, hierarchyActiveTreeCursor } = this.props;

		if (!this.props.hierarchy) {
			await listDrive();
		} else if (this.props.hierarchy && this.props.hierarchy.fullPath !== this.props.selectedFolder) {
			await listDriveForSelectedFolder();
		}

		if (lastActiveGuid && !hierarchyActiveTreeCursor) {
			setActiveTreeCursorForDriveGuid(lastActiveGuid);
		}

		hideSpinner();

		setTimeout(() => {
			this.setState({ driveInitialized: true });
		});
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (nextProps.activeCursor) {
			const currentCursor = this.state.cursor;
			const nextCursor = nextProps.activeCursor;
			const shouldSyncCursor =
				!currentCursor ||
				nextCursor.guid !== currentCursor.guid ||
				(Number(nextCursor.revision) || 0) !== (Number(currentCursor.revision) || 0) ||
				`${nextCursor.path || ""}` !== `${currentCursor.path || ""}` ||
				!_.isEqual(nextCursor.metaData || {}, currentCursor.metaData || {});

			if (shouldSyncCursor) {
				this.setState({ cursor: nextCursor });
			}
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.driveInitialized === true && prevState.driveInitialized === false) {
			this.scrollSelectedItemIntoView();
		}

		if (this.props.settings?.mode !== prevProps.settings?.mode) {
			this.scrollSelectedItemIntoView();
		}

		// keep gallery index in range if images set changes
		if (this.state.galleryImages !== prevState.galleryImages) {
			const len = this.state.galleryImages?.length || 0;
			if (len === 0 && prevState.galleryImages?.length > 0) {
				this.setState({ galleryIndex: 0 });
			} else if (this.state.galleryIndex >= len) {
				this.setState({ galleryIndex: 0 });
			}
		}

		if (this.state.processingUploads !== prevState.processingUploads && _.isEmpty(this.state.processingUploads)) {
			this.stopVideoProcessingPoll();
		}

		if (this.state.showPasteClipboardModal && !prevState.showPasteClipboardModal) {
			this.addPasteClipboardDocumentListener();
			if (this.state.pasteClipboardWaitingForPaste) {
				this.focusPasteClipboardTarget();
			}
		} else if (!this.state.showPasteClipboardModal && prevState.showPasteClipboardModal) {
			this.removePasteClipboardDocumentListener();
		}
	}

	componentWillUnmount() {
		this.stopVideoProcessingPoll();
		this.removePasteClipboardDocumentListener();
		this.revokePasteClipboardPreviewUrl();
	}

	scrollSelectedItemIntoView() {
		const { lastActiveGuid } = this.props;
		if (lastActiveGuid) {
			const el = window.document.getElementById(`drive-node-${this.driveComponentId}-${lastActiveGuid}`);
			if (el) {
				el.scrollIntoView({ block: "center" });
			}
		}
	}
}

export default branch(
	{
		hierarchy: ["drive", "hierarchy"],
		settings: ["drive", "settings"],
		showSpinner: ["drive", "showSpinner"],
		activeCursor: ["drive", "hierarchyActiveCursor"],
		editors: ["driveEditors", "editors"],
		filter: ["drive", "filter"],
		selectedFolder: ["drive", "selectedFolder"],
		lastActiveGuid: ["drive", "lastActiveGuid"],
		hierarchyActiveTreeCursor: ["drive", "hierarchyActiveCursor"],
		editActivity: ["tree", "root", "entity"],
		urlParams: ["appState", "urlParams"]
	},
	Drive
);
